import {cleanParty,partyLines,partyLabels} from "./lh-ddf6a7c5-party-context.js?v=013de4a92b4c";
import {pauseBakeryStory,initBakeryStory} from "./lh-e276babc-bakery-story.js?v=codex-20261027-r14";
import {startBakeryGallery} from "./lh-6ee50f95-bakery-gallery.js?v=codex-20261027-r14";
import {curatePhotographs} from "./lh-d2f85937-product-photographs.js?v=curation-20261029";
import {createShopifyFetch} from "./lh-8cb4d7e1-shopify-transport.js?v=f4266449d0eb";
import {createSharedCart} from "./lh-013457b3-shopify-cart.js?v=mobile-assistant-20261027";
import {
  money,
  receptionLabels,
  categories,
  normalizeCatalogue,
  addLine,
  replaceLine,
  basketSummary,
  partySelection,
  orderMessage,
  newVisit,
  validCompleteVisit,
  today,
  detailIssues,
  persistableCompleteVisit,
  migratePreparedNote,
  waBold,
  waDate,
  isSunday
} from "./lh-114057c3-bakery-complete-order.js?v=43bc451967c5";
let GATE_POSES = {};

const T = (text, ...values) => window.larrysaT ? window.larrysaT(text, ...values) : String(text).replace(/§/g, () => String(values.shift()));
const $ = (sel) => document.querySelector(sel);
const $$ = (sel) => [...document.querySelectorAll(sel)];
const esc = (v) =>
  String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

const VISIT_STORAGE_KEY = 'larrysa-loja-viva-3d-20261015';
const UI_PREFS_STORAGE_KEY = `${VISIT_STORAGE_KEY}:ui-prefs`;
let shopifyFetch,sharedCart,sharedCartRefresh;
async function refreshSharedCart(){
 if(!sharedCart)return;
 if(sharedCartRefresh)return sharedCartRefresh;
 sharedCartRefresh=(async()=>{
  try{visit.basket=await sharedCart.load();updateBasketUI();refreshWhatsappPreviewInPlace();persistVisit();}
  catch(error){showToast(error.message);refreshWhatsappPreviewInPlace();}
 })().finally(()=>{sharedCartRefresh=null;});
 return sharedCartRefresh;
}
function confirmSharedCartExit(){return new Promise(resolve=>{
 const dialog=document.createElement('dialog'),title=document.createElement('h2'),copy=document.createElement('p'),stay=document.createElement('button'),go=document.createElement('button');
 title.id='shared-cart-exit-title';title.textContent=T('Continuar no website?');dialog.setAttribute('aria-labelledby',title.id);
 copy.textContent=T('Os produtos e quantidades acompanham-no. Se indicou uma data na loja, essa data e a receção escolhida serão aplicadas às linhas da Bakery no carrinho. Reveja-nas antes de pedir confirmação. As mensagens e notas pessoais ficam neste separador: copie o resumo para as levar consigo.');
 dialog.style.cssText='max-width:520px;width:calc(100vw - 32px);box-sizing:border-box;padding:28px;border:1px solid #b69779;border-radius:20px;background:#fff8ee;color:#2f2119;font:16px/1.5 system-ui;';
 stay.type=go.type='button';stay.className='secondary';go.className='primary';stay.textContent=T('Rever o pedido');go.textContent=T('Continuar no website');stay.style.marginRight='12px';stay.style.marginBottom='10px';let accepted=false;
 const copyButton=document.createElement('button'),status=document.createElement('p');copyButton.type='button';copyButton.className='secondary';copyButton.textContent=T('Copiar resumo completo');status.setAttribute('role','status');
 copyButton.onclick=async()=>{try{await navigator.clipboard.writeText(humanHandoffText());status.textContent=T('Resumo completo copiado. Pode colá-lo na conversa do WhatsApp.');}catch{status.textContent=T('Não foi possível copiar. Regresse à loja e abra o pedido para o copiar manualmente.');}};
 stay.onclick=()=>dialog.close();go.onclick=async()=>{
  go.disabled=stay.disabled=true;status.textContent=T('A guardar as escolhas no pedido…');
  try{
   if(sharedCart){
    const privateReview=Boolean(visit.details.note||visit.details.dedication||visit.details.allergies||visit.details.zone||visit.preparedText||visit.privateContextPending||visit.unsent||visit.chatMessages?.length||visit.chatHistory?.length||partyPlanner?.getDetails()?.length||Object.keys(visit.brief||{}).length);
    visit.basket=await sharedCart.applyDetails({...(!visit.privateContextPending&&visit.details.date?{date:visit.details.date,receive:visit.details.receive}:{}),privateReview});
    updateBasketUI();persistVisit({immediate:true});
   }
   accepted=true;dialog.close();
  }catch(error){status.textContent=error.message||'Não foi possível guardar. Reveja o pedido antes de continuar.';go.disabled=stay.disabled=false;}
 };dialog.oncancel=e=>{if(go.disabled)e.preventDefault();};dialog.onkeydown=e=>{e.stopPropagation();};dialog.onclose=()=>{dialog.remove();resolve(accepted);};dialog.append(title,copy,copyButton,status,stay,go);document.body.append(dialog);dialog.showModal();stay.focus?.();
 });}
async function commitBasket(next){
 try{visit.basket=sharedCart?await sharedCart.change(visit.basket,next):next;return true;}
 catch(error){showToast(error.message||'Não foi possível atualizar o pedido do website.');refreshWhatsappPreviewInPlace();return false;}
}
function hubFetch(input,options){
  if(!window.LarrysaShopifyConfig)return globalThis.fetch(input,options);
  if(!shopifyFetch){let storage;try{storage=sessionStorage;}catch{}shopifyFetch=createShopifyFetch(window.LarrysaShopifyConfig,globalThis.fetch.bind(globalThis),storage);}
  return shopifyFetch(input,options);
}

// Curated seed overrides matching the verified Bakery rules (including Rubra = framboesa, never amora, and photographic Flor Cítrica)
const SEED_OVERRIDES = {
  rubra: {
    image: new URL("./lh-a3eb4ae7-rubra-hires-recorte.webp",import.meta.url).href,
    displayImage: new URL("./lh-a3eb4ae7-rubra-hires-recorte.webp",import.meta.url).href,
    displayLarge: new URL("./lh-display-rubra-960.webp",import.meta.url).href,
    original: new URL("./lh-73630bc8-rubra-original.jpg",import.meta.url).href,
    presentation: 'cutout',
    shortDescription: 'Chocolate, doce de leite e framboesa'
  },
  'flor-citrica': {
    image: new URL("./lh-40e90721-flor-21-original.jpeg?width=1200",import.meta.url).href,
    displayImage: new URL("./lh-40e90721-flor-21-original.jpeg?width=1200",import.meta.url).href,
    displayLarge: new URL("./lh-40e90721-flor-21-original.jpeg?width=1200",import.meta.url).href,
    original: new URL("./lh-40e90721-flor-21-original.jpeg?width=1200",import.meta.url).href,
    presentation: 'photo',
    photoNote: 'Fotografia original',
    shortDescription: 'Bolo de laranja com uma apresentação florida'
  },
  'cascata-de-ninho': {
    image: new URL("./lh-d222054d-cascata-de-ninho-hires-recorte.webp",import.meta.url).href,
    displayImage: new URL("./lh-d222054d-cascata-de-ninho-hires-recorte.webp",import.meta.url).href,
    displayLarge: new URL("./lh-display-cascata-de-ninho-960.webp",import.meta.url).href,
    original: new URL("./lh-dc41b96e-cascata-de-ninho-original.jpg",import.meta.url).href,
    presentation: 'cutout',
    shortDescription: 'Chocolate com cobertura de leite Ninho'
  },
  'beijo-de-coco': {
    image: 'https://cdn.shopify.com/s/files/1/1061/5760/5189/files/beijo-de-coco-extra-raffaello-01.jpg?v=1790093570',
    displayImage: 'https://cdn.shopify.com/s/files/1/1061/5760/5189/files/beijo-de-coco-extra-raffaello-01.jpg?v=1790093570',
    displayLarge: 'https://cdn.shopify.com/s/files/1/1061/5760/5189/files/beijo-de-coco-extra-raffaello-01.jpg?v=1790093570',
    original: 'https://cdn.shopify.com/s/files/1/1061/5760/5189/files/beijo-de-coco-extra-raffaello-01.jpg?v=1790093570',
    presentation: 'photo',
    shortDescription: 'Bolo de coco com doce de leite e natas, decorado com Raffaello'
  },
  'estrela-de-canela': {
    image: new URL("./lh-display-estrela-de-canela-480.webp",import.meta.url).href,
    displayImage: new URL("./lh-display-estrela-de-canela-480.webp",import.meta.url).href,
    displayLarge: new URL("./lh-display-estrela-de-canela-960.webp",import.meta.url).href,

    presentation: 'cutout',
    shortDescription: 'Bolo de canela'
  }
};

// Vídeos reais da cozinha e texturas macro ("Food Porn") da Larrysa's Bakery
// Only add a motion asset once its origin and the exact product have been verified.
const PRODUCT_FOODPORN_VIDEOS = {};

const videoBlobUrlCache = new Map();

async function getVideoBlobUrl(src) {
  if (!src) return '';
  if (videoBlobUrlCache.has(src)) return videoBlobUrlCache.get(src);
  const p = fetch(src)
    .then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.arrayBuffer();
    })
    .then((buf) => URL.createObjectURL(new Blob([buf], { type: 'video/mp4' })))
    .catch(() => '');
  videoBlobUrlCache.set(src, p);
  return p;
}

async function hydrateVideoElement(videoEl, rawSrc, posterSrc = '') {
  if (!videoEl || !rawSrc) return;
  if (posterSrc) videoEl.poster = posterSrc;
  videoEl.dataset.rawVideoSrc = rawSrc;
  const blobUrl = await getVideoBlobUrl(rawSrc);
  if (!blobUrl || videoEl.dataset.rawVideoSrc !== rawSrc) return;
  if (videoEl.src !== blobUrl) {
    videoEl.src = blobUrl;
  }
  videoEl.muted = true;
  videoEl.playsInline = true;
  videoEl.loop = true;
  videoEl.play?.().catch(() => {});
}

// Missing culinary facts stay absent. Catalogue descriptions remain the authority.
function getServingAndKitchenNote() { return ''; }
function getConservationAndServingNote() { return ''; }
function getRecipeLayers() { return []; }

function detectLisbonLightingMood() {
  try {
    const hourStr = new Intl.DateTimeFormat('pt-PT', {
      timeZone: 'Europe/Lisbon',
      hour: '2-digit',
      hour12: false
    }).format(new Date());
    const h = Number.parseInt(hourStr, 10);
    if (h >= 7 && h < 12) return 'manha';
    if (h >= 12 && h < 19) return 'tarde';
    return 'noite';
  } catch {
    return 'tarde';
  }
}

function getLisbonBakerStatus() {
  return { ticker: 'Bolos, sobremesas e salgados · Pontinha', vitrinaBadge: 'LARRYSA’S BAKERY · PONTINHA' };
}

function computeUpcomingDates() {
  const now = new Date();
  const fmt = (d) => new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Lisbon' }).format(d);
  const tomorrow = new Date(now.getTime() + 86400000);
  const dayOfWeek = now.getDay();
  const daysToSat = (6 - dayOfWeek + 7) % 7 || 7;
  const daysToSun = (7 - dayOfWeek) % 7 || 7;
  const nextSat = new Date(now.getTime() + daysToSat * 86400000);
  const nextSun = new Date(now.getTime() + daysToSun * 86400000);
  return [
    { label: 'Amanhã', value: fmt(tomorrow) },
    { label: 'Este Sábado', value: fmt(nextSat) },
    { label: 'Este Domingo', value: fmt(nextSun) }
  ];
}

function computeTableGuestCapacity(lines = [], targetGuests = 0) {
  return {
    headline: targetGuests ? `${targetGuests} convidados` : 'As suas escolhas, lado a lado',
    detail: 'Rendimento e quantidades a confirmar com a equipa',
    recommendation: null
  };
}

function resolveAssetPath(p) {
  if (!p) return '';
  if (p.startsWith('http://') || p.startsWith('https://') || p.startsWith('/') || p.startsWith('../') || p.startsWith('./')) {
    return p;
  }
  return `../${p}`;
}

let catalogue = [];
let mediaMap = {};
let visit = newVisit();
let visitId = crypto.randomUUID();
let visitStorageAvailable = true;
try {
  visitId = sessionStorage.getItem(VISIT_STORAGE_KEY) || visitId;
  sessionStorage.setItem(VISIT_STORAGE_KEY, visitId);
} catch { visitStorageAvailable = false; }
let revision = 0;
let selectedHandle = 'flor-citrica';
let selectedVariants = {};
let selectedQuantities = {};
let replaceLineId = null;
let replacementProduct = null;
let chatBusy = false;
let pendingRequest = null;
let drawerOpener = null;
let scene3d = null;
let activeStation = 'loja';
let activeShelfCat = 'Destaques';
let activeCategoryFilter = 'Todos';
let searchQuery = '';
let activeTasteFilter = '';
let panelNear = false;
let journeyReady = false;
let catalogueReturn = null;
let galleryIndex = 0;
let galleryHandle = '';
let photoHandle = '';
let photoIndex = 0;
let photoReturnToCompare = false;
let photoOpener = null;
let currentPanelView = 'menu'; // 'menu' | 'welcome' | 'product'
let heroVideoActive = false;
let cpVideoActive = false;
let vitrinaVideoActive = false;
let compareCategory = 'Bolos';
let compareLeftHandle = 'rubra';
let compareRightHandle = 'cascata-de-ninho';
let soundEnabled = false;
let audioCtx = null;
let ambientNodes = null;
let persistTimer = null;

function playPorcelainChime(freq = 587.33) {
  if (!soundEnabled || !audioCtx) return;
  try {
    const now = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, now);
    osc.frequency.exponentialRampToValueAtTime(freq * 1.25, now + 0.14);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.linearRampToValueAtTime(0.025, now + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.24);
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(now);
    osc.stop(now + 0.26);
  } catch {}
}

function toggleBakerySound() {
  soundEnabled = !soundEnabled;
  const btn = $('#sound-toggle-btn');
  if (btn) {
    btn.setAttribute('aria-pressed', String(soundEnabled));
    btn.textContent = T(soundEnabled ? 'Desligar som' : 'Ligar som');
    btn.classList.toggle('is-active', soundEnabled);
  }
  if (!soundEnabled) {
    if (ambientNodes) {
      try {
        ambientNodes.gain.gain.setTargetAtTime(0.0001, audioCtx.currentTime, 0.15);
      } catch {}
    }
    showToast('Ambiente sonoro da pastelaria desligado');
    return;
  }
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!audioCtx && Ctx) audioCtx = new Ctx();
    if (audioCtx?.state === 'suspended') audioCtx.resume();
    if (audioCtx && !ambientNodes) {
      const osc1 = audioCtx.createOscillator();
      const osc2 = audioCtx.createOscillator();
      const filter = audioCtx.createBiquadFilter();
      const gain = audioCtx.createGain();
      osc1.type = 'sine';
      osc2.type = 'triangle';
      osc1.frequency.value = 110; // A2 warm room resonance
      osc2.frequency.value = 164.81; // E3 fifth
      filter.type = 'lowpass';
      filter.frequency.value = 240;
      gain.gain.value = 0.012;
      osc1.connect(filter);
      osc2.connect(filter);
      filter.connect(gain);
      gain.connect(audioCtx.destination);
      osc1.start();
      osc2.start();
      ambientNodes = { osc1, osc2, gain };
    } else if (ambientNodes && audioCtx) {
      ambientNodes.gain.gain.setTargetAtTime(0.012, audioCtx.currentTime, 0.2);
    }
    playPorcelainChime(659.25);
    showToast('Ambiente acústico da pastelaria ativo');
  } catch {
    showToast('Ambiente sonoro ativo');
  }
}

function showToast(msg) {
  const bar = $('#toast-bar');
  const txt = $('#toast-text');
  if (!bar || !txt) return;
  txt.textContent = msg;
  bar.hidden = false;
  clearTimeout(showToast._timer);
  showToast._timer = setTimeout(() => {
    bar.hidden = true;
  }, 4500);
}

function getProduct(handle) {
  return catalogue.find((p) => p.handle === handle) || null;
}

function getSelectedVariant(p) {
  if (!p) return null;
  const chosenId = selectedVariants[p.handle];
  if (chosenId) {
    const found = p.variants.find((v) => v.id === Number(chosenId));
    if (found) return found;
  }
  return p.variants.find((v) => v.available) || p.variants[0] || null;
}

function formatPriceRange(p) {
  if (!p || !p.variants?.length) return '';
  const prices = p.variants.map((v) => v.price);
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  if (min === max) return money(min);
  return `${money(min)} – ${money(max)}`;
}

function compactDesc(p) {
  if (!p) return '';
  if (p.shortDescription) return p.shortDescription;
  const text = p.desc || '';
  const firstSentence = text.split(/(?<=[.!?])\s+/)[0] || text;
  return firstSentence.replace(/[.!]$/, '');
}

async function loadCatalogueAndMedia() {
  if(window.LarrysaShopifyConfig)mediaMap={};
  else try {
    const mr = await fetch('../product-media.json');
    if (mr.ok) {
      mediaMap = await mr.json();
    }
  } catch {
    mediaMap = {};
  }

  Object.entries(SEED_OVERRIDES).forEach(([handle, data]) => {
    mediaMap[handle] = { ...(mediaMap[handle] || {}), ...data };
  });

  const r = await hubFetch('/api/catalogue', { cache: 'no-store' });
  if (!r.ok) throw new Error('Não foi possível carregar o catálogo da Bakery');
  const data = await r.json();
  const normalized = normalizeCatalogue(data.products, mediaMap);
  const originals = new Map(data.products.map(p => [p.handle, curatePhotographs(p)]));

  catalogue = normalized
    .filter((p) => p.category !== 'Vibes da Rua')
    .sort((a, b) => categories.indexOf(a.category) - categories.indexOf(b.category))
    .map((p) => {
      const override = SEED_OVERRIDES[p.handle];
      const localDisplay480 = new URL(`./lh-display-${p.handle}-480.webp`,import.meta.url).href;
      const localDisplay960 = new URL(`./lh-display-${p.handle}-960.webp`,import.meta.url).href;
      const displayImg = override?.displayImage
        ? override.displayImage
        : p.displayImage
          ? resolveAssetPath(p.displayImage)
          : localDisplay480;
      const displayLargeImg = override?.displayImage
        ? override.displayImage
        : p.displayLarge
          ? resolveAssetPath(p.displayLarge)
          : localDisplay960;
      const photographs = originals.get(p.handle) || [];
      const originalImg = photographs[0]?.src || '';
      return {
        ...p,
        slug: p.handle,
        categoryLower: p.category.toLowerCase(),
        categoryLabel: p.category,
        displayImageResolved: originalImg,
        displayLargeResolved: originalImg,
        cutoutImage: displayImg,
        originalImageResolved: originalImg,
        originalDimensions: photographs[0]?.dimensions,
        photographs,
        priceLabel: formatPriceRange(p),
        aspectRatio: p.ratio || 1.15,
        shortDescription: override?.shortDescription || p.shortDescription,
        photoNote: '',
        foodPornMedia: PRODUCT_FOODPORN_VIDEOS[p.handle] || null
      };
    });

  if (!catalogue.length) throw new Error('O catálogo está temporariamente indisponível');

  const countBadge = $('#hud-catalogue-count');
  if (countBadge) countBadge.textContent = String(catalogue.length);

  if (!catalogue.some((p) => p.handle === selectedHandle) && catalogue.length) {
    selectedHandle = catalogue[0].handle;
  }
}

function safeActions(actions) {
  return (actions || [])
    .filter((a) => ['open_product', 'compare_products', 'request_human', 'continue_whatsapp'].includes(a?.type))
    .slice(0, 8)
    .map((a) => {
      const trim = (p) =>
        Object.fromEntries(
          Object.entries(p || {}).filter(([k]) =>
            ['product_handle', 'variant_id', 'variant_title', 'title', 'product_type', 'image', 'price_cents', 'available'].includes(k)
          )
        );
      return {
        type: a.type,
        ...trim(a),
        ...(Array.isArray(a.products) ? { products: a.products.slice(0, 4).map(trim) } : {})
      };
    });
}

function safeBrief(brief) {
  if (!brief || typeof brief !== 'object') return {};
  const out = {};
  if (['aniversário', 'jantar', 'celebração', 'lanche'].includes(brief.occasion)) out.occasion = brief.occasion;
  if (Number.isSafeInteger(brief.people) && brief.people > 0 && brief.people <= 500) out.people = brief.people;
  const party=cleanParty(brief.party); if(party)out.party=party;
  if (typeof brief.flavour === 'string' && brief.flavour.length <= 80) out.flavour = brief.flavour;
  if (['Bolos', 'Sobremesas', 'Salgados'].includes(brief.category)) out.category = brief.category;
  return out;
}

function saveUIPrefs(partial = {}) {
  try {
    const prev = loadUIPrefs();
    const next = {
      direction: document.documentElement.dataset.direction || prev.direction || 'cacau',
      lighting: document.documentElement.dataset.lighting || prev.lighting || 'tarde',
      ...partial
    };
    sessionStorage.setItem(UI_PREFS_STORAGE_KEY, JSON.stringify(next));
    localStorage.setItem(UI_PREFS_STORAGE_KEY, JSON.stringify(next));
  } catch {}
}

function loadUIPrefs() {
  try {
    const raw = sessionStorage.getItem(UI_PREFS_STORAGE_KEY) || localStorage.getItem(UI_PREFS_STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

function syncOvenTicker(mood) {
  const activeMood = mood || document.documentElement.dataset.lighting || 'tarde';
  const status = getLisbonBakerStatus(activeMood);
  const tickerText = $('#live-oven-ticker-text');
  if (tickerText) {
    tickerText.textContent = status.ticker;
  }
  const vitrinaEyebrow = $('#vitrina-live-eyebrow-text');
  if (vitrinaEyebrow) {
    vitrinaEyebrow.textContent = status.vitrinaBadge;
  }
}

async function flushVisitToServer(rev, snapshot) {
  try {
    const r = await hubFetch(`/api/visit/${visitId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ revision: rev, snapshot }),
      keepalive: true
    });
    if (!r.ok) { if (r.status === 409) { const latest = await r.json(); revision = Math.max(revision, Number(latest.revision) || 0); } throw new Error('save'); }
    const receipt = await r.json();
    if (!receipt.accepted) throw new Error('save');
    try { sessionStorage.setItem(`${VISIT_STORAGE_KEY}:persisted`, '1'); }
    catch { visitStorageAvailable = false; }
    $('#drawer-save-banner').hidden = visitStorageAvailable;
    $('#drawer-save-retry').hidden = !visitStorageAvailable;
    if (!visitStorageAvailable) $('#drawer-save-text').textContent = T('As escolhas continuam neste separador. O navegador não garante a recuperação do pedido depois de fechar ou recarregar a página.');
  } catch { $('#drawer-save-text').textContent = T('Não foi possível guardar no servidor. As escolhas continuam neste separador.'); $('#drawer-save-banner').hidden = false; $('#drawer-save-retry').hidden = false; }
}

function persistVisit({ immediate = false } = {}) {
  try {
    visit.viewed = selectedHandle;
    visit.brief = safeBrief(visit.brief);
    visit.chatMessages = (visit.chatMessages || []).slice(-64).map((m) => ({
      role: m.role === 'user' ? 'user' : 'assistant',
      text: String(m.text || '').slice(0, 4000),
      ...(m.actions ? { actions: safeActions(m.actions) } : {})
    }));
    visit.chatHistory = (visit.chatHistory || []).slice(-6).map((m) => ({
      role: m.role === 'user' ? 'user' : 'assistant',
      text: String(m.text || '').slice(0, 600)
    }));
    const snapshot = persistableCompleteVisit(visit);
    if (partyPlanner?.getDetails().length) snapshot.privateContextPending = true;
    if (!validCompleteVisit(snapshot)) return;
    const rev = ++revision;
    try {
      sessionStorage.setItem(`${VISIT_STORAGE_KEY}:snapshot`, JSON.stringify(snapshot));
      sessionStorage.setItem(`${VISIT_STORAGE_KEY}:revision`, String(rev));
    } catch {}
    clearTimeout(persistTimer);
    if (immediate) {
      flushVisitToServer(rev, snapshot);
    } else {
      persistTimer = setTimeout(() => {
        flushVisitToServer(rev, snapshot);
      }, 160);
    }
  } catch {
    // Keep in-memory state gracefully
  }
}

async function restoreVisit() {
  let localSnap = null;
  let localRev = 0;
  try {
    const raw = sessionStorage.getItem(`${VISIT_STORAGE_KEY}:snapshot`);
    localRev = Number(sessionStorage.getItem(`${VISIT_STORAGE_KEY}:revision`) || 0);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (validCompleteVisit(parsed)) {
        localSnap = persistableCompleteVisit(parsed);
        sessionStorage.setItem(`${VISIT_STORAGE_KEY}:snapshot`, JSON.stringify(localSnap));
      }
    }
  } catch {}

  try {
    const hasPersisted = sessionStorage.getItem(`${VISIT_STORAGE_KEY}:persisted`) === '1';
    if (hasPersisted && visitId && /^[a-f0-9-]{36}$/i.test(visitId)) {
      const r = await hubFetch(`/api/visit/${visitId}`);
      if (r.ok) {
        const saved = await r.json();
        const serverRev = Number(saved?.revision || 0);
        if (saved?.snapshot && validCompleteVisit(saved.snapshot) && serverRev >= localRev) {
          visit = persistableCompleteVisit(saved.snapshot);
          revision = serverRev;
          try {
            sessionStorage.setItem(`${VISIT_STORAGE_KEY}:snapshot`, JSON.stringify(visit));
            sessionStorage.setItem(`${VISIT_STORAGE_KEY}:revision`, String(revision));
          } catch { visitStorageAvailable = false; }
          if (visit.viewed && catalogue.some((p) => p.handle === visit.viewed)) {
            selectedHandle = visit.viewed;
          }
          return true;
        }
      }
    }
  } catch {}

  if (localSnap) {
    visit = persistableCompleteVisit(localSnap);
    revision = localRev;
    if (visit.viewed && catalogue.some((p) => p.handle === visit.viewed)) {
      selectedHandle = visit.viewed;
    }
    return true;
  }
  return false;
}

/**
 * Alterna entre as vistas principais do #shop-panel ('menu' | 'welcome' | 'product')
 */
let panelDistanceAnimation;
function setPanelExpanded(expanded) {
  const panel = $('#shop-panel');
  const changed = document.body.classList.contains('mobile-panel-expanded') !== expanded;
  if(changed) panelDistanceAnimation?.cancel();
  const before = changed && journeyReady ? panel?.getBoundingClientRect() : null;
  document.body.classList.toggle('mobile-panel-expanded', expanded);
  const button = $('#panel-distance');
  if (button) { button.textContent = expanded ? 'Voltar à loja' : 'Aproximar do balcão'; button.setAttribute('aria-expanded', String(expanded)); }
  ['spatial-anchors', 'bakery-canvas'].forEach(id => { const el = document.getElementById(id); if (el) el.inert = expanded; });
  const recenter = $('#return-room-entry'); if (recenter) recenter.disabled = expanded;
  if (scene3d) { scene3d.setNavigationEnabled(!expanded); scene3d._updateAnchors(); }
  syncPanelNavigation();
  if (before && panel?.animate && document.body.classList.contains('entrance-proof') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const after = panel.getBoundingClientRect(), scale = Math.min(before.width/after.width, before.height/after.height);
    const parent = panel.offsetParent?.getBoundingClientRect();
    const x = before.left-after.left-(scale-1)*(after.left-(parent?.left||0)-panel.offsetLeft);
    const y = before.top-after.top-(scale-1)*(after.top-(parent?.top||0)-panel.offsetTop);
    panelDistanceAnimation = panel.animate([{translate:`${x}px ${y}px`,scale:String(scale)},{translate:'0px 0px',scale:'1'}],{duration:220,easing:'cubic-bezier(.2,.8,.2,1)'});
  }
}

function goBackInPanel() {
  if (currentPanelView === 'product' && !document.body.dataset.drawer) return returnToExhibition();
  if (document.body.classList.contains('mobile-panel-expanded')) {
    replaceLineId = null;
    setPanelView('welcome');
    $('#panel-back-btn')?.focus({preventScroll:true});
  } else setPanelExpanded(true);
}

function syncPanelNavigation() {
  if (!document.body.classList.contains('entrance-proof')) return;
  const expanded = document.body.classList.contains('mobile-panel-expanded');
  const product = currentPanelView === 'product' && !document.body.dataset.drawer;
  const back = $('#panel-back-btn'), distance = $('#panel-distance');
  if (back) back.textContent = product ? 'Voltar à montra' : expanded ? 'Voltar à loja' : 'Ver de perto';
  if (distance) { distance.textContent = expanded ? 'Voltar à loja' : 'Ver de perto'; distance.hidden = !(expanded && product); }
}

function returnToExhibition() {
  replaceLineId = null;
  if (catalogueReturn) {
    const saved = catalogueReturn; catalogueReturn = null;
    openDrawer('montra');
    $('#drawer-view-montra').scrollTop = saved.scroll;
    const target = [...$$('[data-inspect-on-counter]')].find(el => el.dataset.inspectOnCounter === saved.handle);
    target?.focus({ preventScroll: true });
  } else { openDrawer('montra'); $('#montra-search')?.focus({ preventScroll: true }); }
}

function openStationCatalogue(station, category) {
  activeStation = 'loja';
  if (scene3d) scene3d._syncSceneMode('room');
  $('#station-return-bar').hidden = true;
  renderVitrinaStrip();
  activeCategoryFilter = category || (station === 'bolos' ? 'Bolos' : 'Sobremesas & Salgados');
  searchQuery = ''; activeTasteFilter = ''; $('#montra-search').value = '';
  $$('[data-taste-filter]').forEach(b => b.classList.remove('is-active'));
  catalogueReturn = null;
  openDrawer('montra');
  $('#drawer-view-montra').scrollTop = 0;
}

// The column follows the source ratio; the image itself always renders in full.
function framePhotograph(image, p) {
  image.parentElement.classList.add('photo-frame');
  const [width, height] = p.originalDimensions || [1, 1];
  image.parentElement.style.setProperty('--photo-ratio', width > 0 && height > 0 ? width / height : 1);
  // Unknown metadata never forces a square photo after the original has loaded.
  image.onload = () => {
    if (image.naturalWidth && image.naturalHeight) image.parentElement.style.setProperty('--photo-ratio', image.naturalWidth / image.naturalHeight);
  };
}

function productPhotos(p) {
  return p.photographs?.length ? p.photographs : [{src:p.originalImageResolved,label:'Fotografia original',dimensions:p.originalDimensions}];
}

function showProductPhoto(index) {
  window.BakeryMedia?.stop();
  const p = getProduct(selectedHandle); if (!p) return;
  const photos = productPhotos(p);
  galleryIndex = Math.max(0, Math.min(photos.length - 1, index));
  const photo = photos[galleryIndex];
  const image = $('#cp-image'); framePhotograph(image,{originalDimensions:photo.dimensions}); image.src = photo.src; image.alt = `${p.name} · ${photo.label}`;
  $('#cp-photo-status').textContent = T('§ / § · §', galleryIndex + 1, photos.length, photos[galleryIndex].label);
  $('#cp-photo-prev').disabled = galleryIndex === 0; $('#cp-photo-next').disabled = galleryIndex === photos.length - 1;
  $$('#cp-photo-thumbs button').forEach((b, i) => b.setAttribute('aria-pressed', String(i === galleryIndex)));
}

function renderProductGallery(p) {
  if (galleryHandle !== p.handle) { galleryIndex = 0; galleryHandle = p.handle; }
  const photos = productPhotos(p);
  $('#cp-photo-thumbs').innerHTML = photos.length > 1 ? photos.map(({src, label}, i) => `<button type="button" data-product-photo="${i}" aria-label="${esc(T('Ver fotografia §: §', i + 1, label))}" aria-pressed="${i === galleryIndex}"><img src="${esc(window.BakeryMedia?.url(src,160)||src)}" loading="lazy" alt=""><span>${esc(label)}</span></button>`).join('') : '';
  $('#cp-photo-nav').hidden = photos.length < 2;
  showProductPhoto(galleryIndex);
  window.BakeryMedia?.mount($('#cp-zoom-btn').parentElement,$('#cp-photo-thumbs'),p.handle);
}

function showModalPhoto(index) {
  const p = getProduct(photoHandle); if (!p) return;
  const photos = productPhotos(p); photoIndex = Math.max(0, Math.min(photos.length - 1, index));
  $('#pm-image').src = photos[photoIndex].src; $('#pm-image').alt = `${p.name} · ${photos[photoIndex].label}`;
  $('#pm-image').onload = () => $('#pm-image').style.setProperty('--original-width', `${$('#pm-image').naturalWidth}px`);
  $('#pm-caption').textContent = photos[photoIndex].label.includes('extra Raffaello') ? '' : p.photoNote;
  $('#pm-status').textContent = T('§ / § · §', photoIndex + 1, photos.length, photos[photoIndex].label);
  $('#pm-prev').disabled = photoIndex === 0; $('#pm-next').disabled = photoIndex === photos.length - 1;
  $('#pm-viewport').classList.remove('is-zoomed'); $('#pm-toggle-zoom').textContent = T('Ampliar detalhes');
}

function setPanelView(viewName, {resetScroll = viewName !== currentPanelView} = {}) {
  window.BakeryMedia?.stop();
  if (viewName !== 'product') catalogueReturn = null;
  if (journeyReady) setPanelExpanded(viewName !== 'welcome');
  if (viewName === 'menu' && getProduct(selectedHandle)?.category !== 'Bolos') { selectedHandle = 'rubra'; previewFeaturedCakeInHero(selectedHandle); }
  currentPanelView = viewName;
  document.body.dataset.activeView = viewName;
  closeDrawer();

  const menuEl = $('#panel-view-menu');
  const welcomeEl = $('#welcome-card');
  const productEl = $('#counter-product-card');

  if (menuEl) menuEl.hidden = viewName !== 'menu';
  if (welcomeEl) welcomeEl.hidden = viewName !== 'welcome';
  if (productEl) productEl.hidden = viewName !== 'product';
  if (resetScroll) $('#panel-content').scrollTop = 0;

  $$('.journey li').forEach((li) => {
    if (li.dataset.journeyStep === 'escolher') {
      li.setAttribute('aria-current', 'step');
    } else {
      li.removeAttribute('aria-current');
    }
  });
}

/**
 * Sincroniza o estado de vídeo/foto no Hero do painel central (#panel-view-menu)
 */
function syncHeroMedia(p) {
  const imgEl = $('#hero-cake-img');
  const videoEl = $('#hero-cake-video');
  const toggleBtn = $('#hero-video-toggle');
  if (!imgEl || !p) return;

  framePhotograph(imgEl,p);
  imgEl.src = p.displayImageResolved;
  imgEl.alt = p.name;

  const fp = p.foodPornMedia;
  if (toggleBtn) {
    toggleBtn.hidden = !fp;
    toggleBtn.textContent = T(heroVideoActive ? 'Ver fotografia' : 'Vídeo da cozinha');
    toggleBtn.classList.toggle('is-active', Boolean(heroVideoActive && fp));
  }

  if (videoEl) {
    if (fp && heroVideoActive) {
      imgEl.hidden = true;
      videoEl.hidden = false;
      hydrateVideoElement(videoEl, fp.video, fp.poster || p.displayImageResolved);
    } else {
      videoEl.pause?.();
      videoEl.hidden = true;
      imgEl.hidden = false;
    }
  }
}

/**
 * Atualiza o Hero de destaque dentro de #panel-view-menu (Rubra, Flor Cítrica, Cascata de Ninho, Beijo de Coco)
 */
function previewFeaturedCakeInHero(handle) {
  const p = getProduct(handle);
  if (!p) return;
  selectedHandle = p.handle;
  visit.viewed = p.handle;

  const titleEl = $('#hero-cake-title');
  const descEl = $('#hero-cake-desc');
  const priceEl = $('#hero-cake-price');
  const btnEl = $('#hero-open-product');

  syncHeroMedia(p);

  if (titleEl) titleEl.textContent = p.name;
  if (descEl) descEl.textContent = compactDesc(p);
  if (priceEl) priceEl.textContent = p.priceLabel;
  if (btnEl) {
    btnEl.textContent = T('Ver §', p.name);
    btnEl.dataset.selectProduct = p.handle;
  }

  $$('.display-card[data-featured-cake]').forEach((card) => {
    card.setAttribute('aria-pressed', String(card.dataset.featuredCake === p.handle));
  });

  if (scene3d) {
    scene3d.highlightProductOnCounter({
      slug: p.handle,
      name: p.name,
      categoryLabel: p.category,
      priceLabel: p.priceLabel,
      shortDescription: compactDesc(p),
      cutoutImage: p.cutoutImage,
      displayImage: p.displayImageResolved
    });
  }
}

/**
 * Renderiza o palco completo da Vitrina Refrigerada de Confeitaria (Pâtisserie / Confeitaria)
 * Prateleiras contínuas de vidro temperado e mármore Calacatta sem "caixas SaaS",
 * etiquetas clássicas de marfim e latão escovado, e palco macro Food Porn de largura total.
 */
function renderVitrinaStrip() {
  const strip = $('#vitrina-strip');
  if (!strip) return;
  const isVitrina = activeStation === 'bolos' || activeStation === 'salgados';
  strip.hidden = !isVitrina;
  $('#shop-panel').inert = isVitrina;
  strip.className = isVitrina ? 'vitrina-real-stage' : '';

  $$('.btn-station-switch[data-station]').forEach((btn) => {
    btn.classList.toggle('is-active', btn.dataset.station === activeStation);
  });

  if (!isVitrina) {
    strip.innerHTML = '';
    return;
  }

  // Preservar a posição de scroll horizontal das duas prateleiras antes de atualizar
  const prevTopScroll = strip.querySelector('.shelf-tier-top .vitrina-pedestals-row')?.scrollLeft || 0;
  const prevBottomScroll = strip.querySelector('.shelf-tier-bottom .vitrina-pedestals-row')?.scrollLeft || 0;

  const isBolos = activeStation === 'bolos';
  const signatureHandles = ['rubra', 'flor-citrica', 'cascata-de-ninho', 'beijo-de-coco'];

  const topShelfItems = isBolos
    ? signatureHandles.map((h) => getProduct(h)).filter(Boolean)
    : catalogue.filter((p) => p.category === 'Salgados');

  const bottomShelfItems = isBolos
    ? catalogue.filter((p) => p.category === 'Bolos' && !signatureHandles.includes(p.handle))
    : catalogue.filter((p) => p.category === 'Sobremesas');

  const allStationItems = [...topShelfItems, ...bottomShelfItems];
  if (!allStationItems.some((p) => p.handle === selectedHandle) && allStationItems.length) {
    selectedHandle = allStationItems[0].handle;
  }
  const spotProd = getProduct(selectedHandle) || allStationItems[0];
  const spotVar = getSelectedVariant(spotProd);
  const spotFp = spotProd?.foodPornMedia || {
    video: '',
    poster: spotProd?.displayLargeResolved || '',
    badge: '',
    caption: ''
  };

  const activeMood = document.documentElement.dataset.lighting || 'tarde';
  const bakerStatus = getLisbonBakerStatus(activeMood);
  const pipVideo = isBolos ? './media/hub-viva-rubra-540.mp4' : './media/intro-glace.mp4';
  const pipPoster = (getProduct(isBolos ? 'rubra' : 'beijo-de-coco') || spotProd)?.displayLargeResolved || spotProd?.displayImageResolved || '';
  const pipTitle = isBolos ? 'Bancada de Bolos · Pontinha' : 'Forno & Pastelaria · Pontinha';
  const pipCaption = isBolos
    ? 'Bolos para a sua celebração'
    : 'Sobremesas e salgados para compor a mesa';

  const renderShelfPiece = (p, isSignature = false) => {
    const isSelected = p.handle === spotProd?.handle;
    return `
      <div class="vitrina-chip vitrina-pedestal-card ${isSignature ? 'is-signature-pedestal' : ''} ${isSelected ? 'is-selected' : ''}">
        <button type="button" class="vitrina-chip-select pedestal-hit" data-vitrina-spot="${esc(p.handle)}" aria-pressed="${isSelected}">
          <span class="pedestal-figure">
            <img src="${esc(p.displayLargeResolved || p.displayImageResolved)}" alt="${esc(p.name)}" ${p.originalDimensions ? `width="${p.originalDimensions[0]}" height="${p.originalDimensions[1]}"` : ''} loading="lazy" />
            <span class="pedestal-contact-shadow" aria-hidden="true"></span>
          </span>
          <span class="pedestal-plaque confectionery-label">
            <strong>${esc(p.name)}</strong>
            <small class="pedestal-flavour">${esc(T(compactDesc(p)))}</small>
            <em class="pedestal-price">${esc(p.priceLabel)}</em>
          </span>
        </button>
        <button type="button" class="vitrina-chip-add" data-vitrina-quick-add="${esc(p.handle)}" aria-label="${esc(T('Juntar § ao pedido', p.name))}" title="${esc(T('Juntar § ao pedido', p.name))}">+ Pedir</button>
      </div>
    `;
  };

  strip.innerHTML = `
    <div class="vitrina-cabinet-layout">
      <div class="vitrina-shelves-col">
        <header class="vitrina-cabinet-header">
          <div>
            <p class="vitrina-eyebrow">
              <span class="live-pulse"></span>
              <span id="vitrina-live-eyebrow-text">${esc(bakerStatus.vitrinaBadge)}</span>
            </p>
            <h2>${
              isBolos
                ? 'Vitrina de Bolos Artesanais · <em>14 Bolos da Nossa Cozinha</em>'
                : 'Vitrina de Sobremesas &amp; Salgados · <em>20 Receitas da Nossa Cozinha</em>'
            }</h2>
          </div>
          <div class="vitrina-kitchen-pip">
            <video data-vitrina-video="${esc(pipVideo)}" poster="${esc(pipPoster)}" muted loop playsinline></video>
            <div>
              <strong>${esc(pipTitle)}</strong>
              <span>${esc(pipCaption)}</span>
            </div>
          </div>
        </header>

        <section class="vitrina-glass-shelf shelf-tier-top" aria-label="Prateleira superior da vitrina">
          <div class="shelf-brass-rail">
            <span>${
              isBolos
                ? 'PRATELEIRA SUPERIOR · OS QUATRO BOLOS DE ASSINATURA'
                : 'PRATELEIRA SUPERIOR · SOBREMESAS DE VITRINA (12 RECEITAS)'
            }</span>
            <small>Fotografias reais da nossa pastelaria</small>
          </div>
          <div class="vitrina-pedestals-row ${isBolos ? 'is-hero-4-grid' : 'is-scroll-shelf'}">
            ${topShelfItems.map((p) => renderShelfPiece(p, isBolos)).join('')}
          </div>
          <div class="shelf-glass-ledge" aria-hidden="true"></div>
        </section>

        <section class="vitrina-glass-shelf shelf-tier-bottom" aria-label="Prateleira inferior da vitrina">
          <div class="shelf-brass-rail">
            <span>${
              isBolos
                ? 'BOLOS PARA CELEBRAR E PARTILHAR'
                : 'PRATELEIRA INFERIOR · SALGADOS &amp; FOLARES (8 RECEITAS)'
            }</span>
            <small>Toque num prato para ver a textura de perto ou pedir</small>
          </div>
          <div class="vitrina-pedestals-row is-scroll-shelf">
            ${bottomShelfItems.map((p) => renderShelfPiece(p, false)).join('')}
          </div>
          <div class="shelf-marble-deck" aria-hidden="true"></div>
        </section>
      </div>

      ${
        spotProd
          ? `
        <aside class="vitrina-spotlight-col" aria-label="Detalhe do produto na vitrina">
          <div class="vitrina-spot-header">
            <span class="vitrina-fidelity-pill">Da nossa montra</span>
            <button type="button" class="vitrina-open-original-link" data-vitrina-open-photo="${esc(spotProd.handle)}">
              Ver fotografia original ↗
            </button>
          </div>

          <div class="vitrina-spot-stage ${vitrinaVideoActive ? 'is-video-mode' : 'is-cutout-mode'}">
            <div class="vitrina-spot-video-box" ${vitrinaVideoActive ? '' : 'hidden'}>
              <video data-vitrina-video="${esc(spotFp.video)}" poster="${esc(spotFp.poster || spotProd.displayImageResolved)}" muted loop playsinline></video>
              <button type="button" class="spot-cutout-medallion" data-vitrina-toggle-media title="Ver fotografia">
                <img src="${esc(spotProd.displayLargeResolved || spotProd.displayImageResolved)}" alt="${esc(spotProd.name)}" />
                <span>Ver recorte</span>
              </button>
              <span class="spot-video-badge">${esc(spotFp.badge)}</span>
            </div>
            <div class="vitrina-spot-cutout-box" ${vitrinaVideoActive ? 'hidden' : ''}>
              <img src="${esc(spotProd.displayLargeResolved || spotProd.displayImageResolved)}" alt="${esc(spotProd.name)}" />
              <button type="button" class="spot-toggle-video-pill" data-vitrina-toggle-media ${spotProd.foodPornMedia ? '' : 'hidden'}>
                Ver vídeo da cozinha
              </button>
            </div>
          </div>

          <div class="vitrina-spot-copy">
            <p class="eyebrow">${esc(T(spotProd.category))} · Na Nossa Vitrina</p>
            <h3>${esc(spotProd.name)}</h3>
            <p class="vitrina-spot-desc">${esc(T(compactDesc(spotProd)))}</p>
            <div class="recipe-layers-strip" aria-label="Camadas reais da receita" ${getRecipeLayers(spotProd).length ? '' : 'hidden'}>
              ${getRecipeLayers(spotProd)
                .map((layer, idx) => `<span class="recipe-layer-pill"><small>${idx + 1}</small> ${esc(layer)}</span>`)
                .join('')}
            </div>
            <p class="vitrina-spot-kitchen-note">${esc(getServingAndKitchenNote(spotProd))}</p>
            <p class="vitrina-spot-conservation-note">${esc(getConservationAndServingNote(spotProd))}</p>

            <div class="vitrina-spot-price-row">
              <strong>${spotVar ? money(spotVar.price) : esc(spotProd.priceLabel)}</strong>
              ${
                spotProd.variants.length > 1
                  ? `
                  <label class="sr-only" for="vitrina-spot-variant">Formato</label>
                  <select id="vitrina-spot-variant" data-vitrina-variant="${esc(spotProd.handle)}">
                    ${spotProd.variants
                      .map(
                        (v) => `
                        <option value="${v.id}" ${spotVar?.id === v.id ? 'selected' : ''}>
                          ${esc(T(v.title))} · ${money(v.price)}
                        </option>
                      `
                      )
                      .join('')}
                  </select>
                `
                  : `<span class="vitrina-unit-tag">Unidade inteira</span>`
              }
            </div>

            <div class="vitrina-spot-actions">
              <button type="button" class="primary" data-vitrina-spot-add="${esc(spotProd.handle)}">
                + Juntar ${esc(spotProd.name)} · ${spotVar ? money(spotVar.price) : esc(spotProd.priceLabel)}
              </button>
              <div class="vitrina-spot-subactions">
                <button type="button" class="secondary" data-open-compare="${esc(spotProd.handle)}">
                  Comparar produtos
                </button>
                <button type="button" class="secondary" data-select-product="${esc(spotProd.handle)}">
                  Ver no painel central
                </button>
                <button type="button" class="secondary" data-vitrina-ask="${esc(spotProd.handle)}">
                  Dúvidas? Fale connosco
                </button>
              </div>
            </div>
          </div>
        </aside>
      `
          : ''
      }
    </div>
  `;

  const newTopRow = strip.querySelector('.shelf-tier-top .vitrina-pedestals-row');
  const newBottomRow = strip.querySelector('.shelf-tier-bottom .vitrina-pedestals-row');
  if (newTopRow && prevTopScroll > 0) newTopRow.scrollLeft = prevTopScroll;
  if (newBottomRow && prevBottomScroll > 0) newBottomRow.scrollLeft = prevBottomScroll;

  strip.querySelectorAll('video[data-vitrina-video]').forEach((vEl) => {
    hydrateVideoElement(vEl, vEl.dataset.vitrinaVideo, vEl.getAttribute('poster') || '');
  });
}

function readProductQuantity(raw) {
  const n = String(raw ?? '').trim() === '' ? NaN : Number(raw);
  return Number.isSafeInteger(n) && n >= 1 && n <= 99 ? n : null;
}

function updateCounterProductPriceAndCTA(p, qty) {
  if (!p) return;
  const currentVar = getSelectedVariant(p);
  const valid = readProductQuantity(qty) !== null;
  const totalFormatted = currentVar ? money(currentVar.price * (valid ? qty : 1)) : p.priceLabel;
  const input = $('#cp-qty'), error = $('#cp-qty-error');
  input?.setAttribute('aria-invalid', String(!valid));
  input?.setCustomValidity?.(valid ? '' : 'Escolha uma quantidade inteira entre 1 e 99');
  if (error) { error.hidden = valid; error.textContent = valid ? '' : 'Escolha uma quantidade inteira entre 1 e 99'; }
  const priceEl = $('#cp-price');
  if (priceEl) priceEl.textContent = totalFormatted;
  const addBtn = $('#cp-add-btn');
  if (addBtn) {
    addBtn.disabled = !valid;
    const label = T(!valid ? 'Reveja a quantidade'
      : replaceLineId ? `Trocar por ${p.name} · ${totalFormatted}`
      : qty > 1 ? `Adicionar ${qty}× ao pedido · ${totalFormatted}`
      : `Adicionar ao pedido · ${totalFormatted}`);
    // Safari can cancel a pending click when blur replaces its target text node.
    if (addBtn.textContent !== label) addBtn.textContent = label;
  }
}

/**
 * Abre e preenche a Ficha de Produto (#counter-product-card) dentro do #shop-panel
 */
function openCounterProductCard(handle, { moveCameraToCounter = false } = {}) {
  const p = getProduct(handle);
  if (!p) return;
  const resetScroll = currentPanelView !== 'product' || selectedHandle !== p.handle;
  if (document.body.dataset.drawer === 'montra') catalogueReturn = {scroll: $('#drawer-view-montra').scrollTop, handle: p.handle};
  setPanelExpanded(true);
  selectedHandle = p.handle;
  visit.viewed = p.handle;

  // Garantir que estamos no modo sala para ver o painel central
  if (scene3d && scene3d.activeMode !== 'room') {
    activeStation = 'loja';
    scene3d.goToStation('loja');
    const retBar = $('#station-return-bar');
    if (retBar) retBar.hidden = true;
  }

  // Atualizar também o Hero caso o utilizador volte à montra
  previewFeaturedCakeInHero(p.handle);

  if (replaceLineId && replacementProduct !== p.handle) {
    const line = visit.basket.find(l => l.id === replaceLineId);
    if (line) selectedQuantities[p.handle] = line.quantity;
    replacementProduct = p.handle;
  }
  setPanelView('product', {resetScroll});

  $('#cp-category').textContent = T(`A explorar: ${p.name} · ${p.category}`);
  $('#cp-title').textContent = p.name;
  $('#cp-desc').textContent = compactDesc(p);

  const layersEl = $('#cp-recipe-layers');
  if (layersEl) {
    const layers = getRecipeLayers(p);
    layersEl.innerHTML = layers
      .map((layer, idx) => `<span class="recipe-layer-pill"><small>${idx + 1}</small> ${esc(layer)}</span>`)
      .join('');
    layersEl.hidden = layers.length === 0;
  }

  const kitchenNoteEl = $('#cp-kitchen-note');
  if (kitchenNoteEl) {
    kitchenNoteEl.textContent = getServingAndKitchenNote(p);
  }

  const consNoteEl = $('#cp-conservation-note');
  if (consNoteEl) {
    consNoteEl.textContent = getConservationAndServingNote(p);
  }

  const disclosure = $('.poster-details');
  if (disclosure) disclosure.hidden = ![layersEl, kitchenNoteEl, consNoteEl].some(el => el?.textContent.trim());

  const imgEl = $('#cp-image');
  const videoEl = $('#cp-video');
  const videoToggleBtn = $('#cp-video-toggle');
  const fp = window.BakeryCuratedMedia?.[p.handle]?.video ? null : p.foodPornMedia;

  imgEl.src = p.displayLargeResolved || p.displayImageResolved;
  imgEl.alt = p.name;
  renderProductGallery(p);

  if (videoToggleBtn) {
    videoToggleBtn.hidden = !fp;
    videoToggleBtn.textContent = T(cpVideoActive && fp ? 'Ver fotografia' : 'Vídeo da cozinha');
    videoToggleBtn.classList.toggle('is-active', Boolean(cpVideoActive && fp));
  }

  if (videoEl) {
    if (fp && cpVideoActive) {
      imgEl.hidden = true;
      videoEl.hidden = false;
      hydrateVideoElement(videoEl, fp.video, fp.poster || p.displayImageResolved);
    } else {
      videoEl.pause?.();
      videoEl.hidden = true;
      imgEl.hidden = false;
    }
  }

  const noteEl = $('#cp-fidelity-badge');
  if (p.photoNote) {
    noteEl.textContent = p.photoNote;
    noteEl.hidden = false;
  } else if (fp) {
    noteEl.textContent = fp.caption;
    noteEl.hidden = false;
  } else {
    noteEl.hidden = true;
  }

  // Variantes (amostras visíveis táteis + select sincronizado)
  const variantWrap = $('#cp-variant-wrap');
  const variantSelect = $('#cp-variant');
  const formatSwatches = $('#cp-format-swatches');
  const currentVar = getSelectedVariant(p);

  if (p.variants.length > 1) {
    variantWrap.hidden = false;
    variantSelect.innerHTML = p.variants
      .map(
        (v) => `
        <option value="${v.id}" ${currentVar?.id === v.id ? 'selected' : ''} ${v.available ? '' : 'disabled'}>
          ${esc(T(v.title))} · ${money(v.price)}
        </option>
      `
      )
      .join('');
    if (formatSwatches) {
      formatSwatches.innerHTML = p.variants
        .map(
          (v) => `
          <button type="button" class="cp-format-swatch ${currentVar?.id === v.id ? 'is-active' : ''}" data-cp-swatch-variant="${v.id}" aria-pressed="${currentVar?.id === v.id}" ${v.available ? '' : 'disabled'}>
            <strong>${esc(T(v.title))}</strong>
            <small>${money(v.price)}</small>
          </button>
        `
        )
        .join('');
    }
  } else {
    variantWrap.hidden = true;
    if (formatSwatches) formatSwatches.innerHTML = '';
  }

  const qty = selectedQuantities[p.handle] || 1;
  const qtyInput = $('#cp-qty');
  if (qtyInput) qtyInput.value = String(qty);

  updateCounterProductPriceAndCTA(p, qty);

  // Replacement starts only from an explicit basket line, never from a category match.
  const swapBtn = $('#cp-swap-btn');
  if (swapBtn) { swapBtn.hidden = true; delete swapBtn.dataset.swapLineId; }

  renderVitrinaStrip();
}

async function addCurrentProductToBasket(explicitHandle = null, explicitQty = null, explicitReplacement = null) {
  const p = getProduct(explicitHandle || selectedHandle);
  if (!p) return;
  if (explicitHandle && p.variants.length > 1) {
    replaceLineId = explicitReplacement || null;
    openCounterProductCard(p.handle);
    return;
  }
  const v = getSelectedVariant(p);
  if (!v) {
    showToast('Escolha um formato disponível');
    return;
  }
  const q = readProductQuantity(explicitQty ?? (explicitHandle ? selectedQuantities[p.handle] ?? 1 : $('#cp-qty')?.value));
  if (q === null) { showToast('Escolha uma quantidade inteira entre 1 e 99'); return; }
  selectedQuantities[p.handle] = q;

  const replacementIntent = replaceLineId;
  const replacementTarget = explicitReplacement || (!explicitHandle ? replacementIntent : null);

  try {
    // Build the requested edit from the fresh basket when focus triggered a read.
    if(sharedCartRefresh)await sharedCartRefresh;
    if (replacementTarget) {
      if(!await commitBasket(replaceLine(visit.basket, replacementTarget, catalogue, p.handle, v.id, q)))return;
      if (replaceLineId === replacementIntent) replaceLineId = null;
      showToast(`Substituído por ${p.name} no seu pedido`);
    } else {
      if (replaceLineId === replacementIntent) replaceLineId = null;
      if(!await commitBasket(addLine(visit.basket, catalogue, p.handle, v.id, q)))return;
      showToast(`${p.name} está no seu pedido`);
    }
    updateBasketUI();
    const drawerOpen = Boolean($('#store-drawer') && !$('#store-drawer').hidden);
    if (activeStation !== 'bolos' && activeStation !== 'salgados') {
      if (!drawerOpen) {
        openCounterProductCard(p.handle);
      }
    } else {
      renderVitrinaStrip();
    }
    persistVisit();
  } catch (err) {
    showToast(err.message || 'Não foi possível atualizar o pedido');
  }
}

function updateBasketUI() {
  const sum = basketSummary(visit.basket, catalogue);
  const count = visit.basket.reduce((acc, l) => acc + l.quantity, 0) + (sharedCart?.otherItemCount || 0);

  const hudCount = $('#hud-basket-count');
  const drawerCount = $('#drawer-basket-count');
  if (hudCount) hudCount.textContent = String(count);
  if (drawerCount) drawerCount.textContent = String(count);

  const resumeBtn = $('#welcome-resume-order');
  if (resumeBtn) resumeBtn.hidden = count === 0;

  if (scene3d) {
    const activeProd = getProduct(selectedHandle);
    scene3d.updateBoardStatus({
      basketCount: count,
      basketTotal: money(sum.total),
      selectedProduct: activeProd
        ? {
            name: activeProd.name,
            categoryLabel: activeProd.category,
            priceLabel: activeProd.priceLabel
          }
        : null
    });
  }

  renderOrderDrawer();
}

function renderMontraGrid() {
  const grid = $('#montra-grid');
  if (!grid) return;

  const q = searchQuery
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase();

  const tastePatterns = {chocolate:/chocolate|cacau|brigadeiro/i,framboesa:/framboesa|morango/i,laranja:/laranja|lim[aã]o|citrin/i,ninho:/ninho|coco/i};
  const filtered = catalogue.filter((p) => {
    const matchCat = activeCategoryFilter === 'Todos' || p.category === activeCategoryFilter || activeCategoryFilter === 'Sobremesas & Salgados' && p.category !== 'Bolos';
    const matchSearch =
      !q ||
      [p.name, p.desc, ...(p.tags || [])]
        .join(' ')
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .includes(q);
    const tasteText = [p.name,p.desc,...(p.tags || [])].join(' ');
    const matchTaste = !activeTasteFilter || (activeTasteFilter === 'camarão' ? p.category === 'Salgados' : tastePatterns[activeTasteFilter]?.test(tasteText));
    return matchCat && matchSearch && matchTaste;
  });

  if (!filtered.length) {
    grid.innerHTML = `
      <div style="grid-column:1/-1;padding:24px;text-align:center;color:var(--muted)">
        <p>Não encontrámos produtos com essa pesquisa. Experimente outro sabor ou volte a ver a montra completa.</p>
      </div>
    `;
    return;
  }

  const swapBanner = replaceLineId
    ? `<div style="grid-column:1/-1;display:flex;align-items:center;justify-content:space-between;padding:8px 12px;background:var(--hazel);border:1px solid var(--line);border-radius:12px;font-size:12px">
        <span>Modo de substituição ativo: escolha o produto para trocar no seu pedido</span>
        <button type="button" class="text-button" data-cancel-swap>Cancelar troca ✕</button>
      </div>`
    : '';

  grid.innerHTML =
    swapBanner +
    filtered
      .map(
        (p) => `
      <article class="montra-card" data-montra-product="${esc(p.handle)}">
        <div>
          <div class="montra-card-heading"><h3>${esc(p.name)}</h3><strong>${esc(p.priceLabel)}</strong></div>
          <div class="montra-card-thumb">
            <img src="${esc(p.displayImageResolved)}" alt="${esc(p.name)}" ${p.originalDimensions ? `width="${p.originalDimensions[0]}" height="${p.originalDimensions[1]}"` : ''} loading="lazy" />
          </div>
          <p class="eyebrow">${esc(T(p.category))}</p>
          <p>${esc(T(compactDesc(p)))}</p>
        </div>
        <div class="montra-card-foot">
          <button type="button" class="secondary" data-inspect-on-counter="${esc(p.handle)}">
            ${replaceLineId ? 'Escolher para troca' : 'Ver produto'}
          </button>
        </div>
      </article>
    `
      )
      .join('');
  filtered.forEach(p => framePhotograph(grid.querySelector(`[data-montra-product="${p.handle}"] img`),p));
}

function renderChatMessages() {
  const log = $('#chat-log');
  if (!log) return;

  const messages = visit.chatMessages.length
    ? visit.chatMessages
    : [
        {
          role: 'assistant',
          text: 'Olá! Sou o Assistente da Bakery, um assistente virtual.\nProcura um bolo, salgados ou uma sobremesa?'
        }
      ];

  const quickPrompts = $('#chat-quick-prompts');
  if (quickPrompts) {
    quickPrompts.hidden = visit.chatMessages.length > 0;
    quickPrompts.innerHTML = faqButtonsHtml();
  }

  const pillsEl = $('#chat-brief-pills');
  if (pillsEl) {
    const entries = Object.entries(visit.brief || {}).filter(([k, v]) => k !== 'party' && v).map(([k,v])=>[k,k==='people'?v+' pessoas':v]);
    if(visit.brief.party?.cake)entries.push(['cake',partyLabels.cake[visit.brief.party.cake]]);
    pillsEl.innerHTML = entries
      .slice(0, 3)
      .map(([, val]) => `<span class="brief-pill">${esc(val)}</span>`)
      .join('');
  }

  const plannerEntry=$('#chat-planner-entry'); if(plannerEntry){plannerEntry.hidden=false;plannerEntry.textContent=T(visit.brief.party?.active?'Continuar no planeador de festa':'Planear uma festa');}
  log.innerHTML = messages
    .map((m) => {
      const recsHtml = m.role === 'assistant' ? renderAssistantRecs(m.actions || []) : '';
      return `
        <div class="chat-bubble ${esc(m.role)}">
          <div>${esc(m.text)}</div>
          ${recsHtml}
        </div>
      `;
    })
    .join('');

  // Posicionar no topo da última resposta da Larrysa para ler o texto e ver os cartões em simultâneo
  const bubbles = log.querySelectorAll('.chat-bubble.assistant');
  const lastBubble = bubbles[bubbles.length - 1];
  if (lastBubble && visit.chatMessages.length > 0) {
    log.scrollTop = Math.max(0, lastBubble.offsetTop - log.offsetTop - 6);
  } else {
    log.scrollTop = log.scrollHeight;
  }
  if (visit.chatMessages.at(-1)?.role === 'assistant' && document.body.dataset.drawer === 'ajuda' && matchMedia('(max-height:500px)').matches) {
    log.scrollIntoView({block:'start'});
  }
}

function humanHandoffNote() {
  return [...new Set(visit.chatMessages.filter(m => m.role === 'user').slice(-6).map(m => m.text).concat(visit.unsent || ''))].filter(Boolean).join('\n\n');
}

function humanHandoffContext() {
  const summary = basketSummary(visit.basket, catalogue);
  const choices = summary.lines.map(l => `${l.product?.name || 'Produto por rever'}${l.variant && !/^Default(?: Title)?$/i.test(l.variant.title) ? ' · ' + l.variant.title : ''} · Quantidade: ${l.quantity}${l.valid ? '' : ' · por confirmar'}`);
  return ["Olá, Larrysa's Bakery! Gostaria de esclarecer algumas questões.", '', ...(choices.length ? ['*Escolhas em preparação (ainda não confirmadas):*', ...choices] : []),
    ...(visit.details.date ? ['Para quando precisa: ' + waDate(visit.details.date) + (detailIssues(visit.details).date ? ' · precisa de revisão' : '')] : []),
    'Receção: Recolha na Pontinha',
    ...(visit.brief.people ? [visit.brief.people + ' pessoas · quantidades a confirmar'] : []),
    ...partyLines(visit.brief.party),
    ...(partyPlanner?.getDetails() || []),
    ...(visit.details.allergies ? ['Alergias ou intolerâncias: ' + visit.details.allergies] : []),
    ...(visit.details.dedication ? ['Dedicatória: ' + visit.details.dedication] : []),
    ...(visit.details.note ? ['Observações: ' + visit.details.note] : []),
    ...(visit.preparedText ? ['Mensagem adicional: ' + visit.preparedText] : [])].map(waBold).join('\n').replace(/\n{3,}/g, '\n\n');
}

function humanHandoffText(note = humanHandoffNote()) {
  return [humanHandoffContext(), note ? 'Mensagem e questões para a equipa\n' + note : '', 'Aguardo confirmação da equipa; este resumo não confirma uma encomenda.'].filter(Boolean).join('\n\n');
}

function openHumanHandoff() {
  const opener = document.activeElement, dialog = document.createElement('dialog');
  dialog.className = 'hub-human-dialog';
  dialog.setAttribute('aria-labelledby', 'hub-human-title');
  dialog.innerHTML = `<h2 id="hub-human-title">Resumo do pedido</h2><p>Reveja o contexto e acrescente as questões que gostaria de esclarecer. Nenhuma mensagem foi enviada.</p>
    <label>O seu pedido<textarea rows="5" readonly>${esc(humanHandoffContext())}</textarea></label>
    <p>Para alterar produtos ou quantidades, regresse ao pedido.</p>
    <label>Mensagem e questões para a equipa<textarea data-human-note rows="5" maxlength="6000">${esc(humanHandoffNote())}</textarea></label>
    <p data-human-status role="status">Copie o resumo completo e cole-no na conversa do WhatsApp. Os textos pessoais não entram na ligação.</p>
    <div class="human-actions"><button type="button" class="primary" data-human-copy>1. Copiar resumo</button><a class="primary" href="https://wa.me/${window.LARRYSA_WA||''}" target="_blank" rel="noopener noreferrer">2. Abrir WhatsApp ↗</a><button type="button" data-human-close>Voltar à loja</button></div>`;
  dialog.querySelector('[data-human-close]').onclick = () => dialog.close();
  dialog.querySelector('[data-human-copy]').onclick = async () => {
    const note = dialog.querySelector('[data-human-note]'), status = dialog.querySelector('[data-human-status]');
    const text = humanHandoffText(note.value);
    try { await navigator.clipboard.writeText(text); status.textContent = T('Resumo copiado. Abra o WhatsApp e cole-no na conversa antes de enviar.'); }
    catch { const preview = dialog.querySelector('textarea[readonly]'); preview.value = text; preview.setAttribute('aria-label', 'Resumo completo para copiar'); preview.focus(); preview.select(); status.textContent = T('Não foi possível copiar automaticamente. O resumo completo está selecionado; copie-no antes de abrir o WhatsApp.'); }
  };
  dialog.onkeydown = e => e.stopPropagation();
  dialog.onclose = () => { dialog.remove(); opener?.focus?.(); };
  document.body.append(dialog); dialog.showModal(); dialog.querySelector('[data-human-note]').focus();
}

function renderAssistantRecs(actions = []) {
  const human = actions.some(a => ['request_human', 'continue_whatsapp'].includes(a.type));
  const handoff = human ? '<button type="button" class="primary" data-human-handoff>Rever o pedido</button>' : '';
  const items = actions.flatMap((a) => a.products || (a.product_handle ? [a] : []));
  const seen = new Set();
  const valid = items
    .filter((a) => {
      if (!a.product_handle || seen.has(a.product_handle)) return false;
      seen.add(a.product_handle);
      return catalogue.some((p) => p.handle === a.product_handle);
    })
    .slice(0, 4);

  if (!valid.length) return handoff;

  const compareBtnHtml =
    valid.length >= 2
      ? `
      <div class="chat-recs-compare-bar">
        <button type="button" class="secondary" data-compare-pair="${esc(valid[0].product_handle)}:${esc(valid[1].product_handle)}" data-open-compare="${esc(valid[0].product_handle)}">
          Comparar ${esc(getProduct(valid[0].product_handle)?.name || '1.º')} vs ${esc(getProduct(valid[1].product_handle)?.name || '2.º')} no balcão
        </button>
      </div>
    `
      : '';

  return `
    <div class="chat-recs">
      ${valid
        .map((a) => {
          const p = getProduct(a.product_handle);

          return `
            <div class="chat-rec-card">
              <div class="chat-rec-main">
                <img src="${esc(p.displayImageResolved)}" alt="${esc(p.name)}" />
                <div>
                  <strong>${esc(p.name)}</strong><br>
                  <small>${esc(p.priceLabel)}</small>
                </div>
              </div>
              <div class="chat-rec-actions">
                <button type="button" class="secondary" data-chat-inspect="${esc(p.handle)}">Ver produto</button>
                <button type="button" class="primary" data-chat-add="${esc(p.handle)}">${p.variants.length > 1 ? 'Escolher formato' : 'Adicionar ao pedido'}</button>
              </div>
            </div>
          `;
        })
        .join('')}
    </div>
    ${compareBtnHtml}
    ${handoff}
  `;
}

async function sendMessageToLarrysa(rawText, { retry = false } = {}) {
  const pending = pendingRequest?.message === String(rawText || '').trim() ? pendingRequest : null;
  retry = Boolean(pending);
  const text = String(pending?.message || rawText || '').trim();
  if (!text || chatBusy) return;

  chatBusy = true;
  const handoffEl = $('#chat-fallback');
  if(handoffEl)handoffEl.hidden=true;
  const statusEl = $('#chat-status');
  if (statusEl) statusEl.textContent = T('A preparar uma sugestão…');

  const last = visit.chatMessages.at(-1);
  if (last?.role !== 'user' || last.text !== text) visit.chatMessages.push({ role: 'user', text });
  if (!retry) visit.unsent = text;
  persistVisit();
  $('#chat-send-btn').disabled = true;
  $('#chat-retry-btn').hidden = true;
  renderChatMessages();

  const inputEl = $('#chat-input');
  if (inputEl && !retry) inputEl.value = text;

  try {
    const payload = retry && pending ? pending : {
      message: text,
      request_id: crypto.randomUUID(),
      history: visit.chatHistory.slice(-6),
      brief: structuredClone(visit.brief),
      experience: 'bakery-complete',
      draft: {
        date: visit.details.date,
        receive: visit.details.receive,
        quantity: 1
      },
      viewed_product: selectedHandle,
      basket: visit.basket.map(({ product_handle, variant_id, quantity }) => ({
        product_handle,
        variant_id,
        quantity
      })),
      ...(visit.conversation ? { conversation: visit.conversation } : {})
    };

    pendingRequest = JSON.parse(JSON.stringify(payload));
    let r = await hubFetch('/api/larrysa-third', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: AbortSignal.timeout(25000)
    });

    if (r.status === 409 && (await r.clone().json()).error === 'session_expired') {
      payload.request_id = crypto.randomUUID();
      delete payload.conversation;
      delete visit.conversation;
      pendingRequest = JSON.parse(JSON.stringify(payload));
      r = await hubFetch('/api/larrysa-third', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: AbortSignal.timeout(25000)
      });
    }

    if (!r.ok) throw new Error('Falha na ligação');
    const reply = await r.json();
    if (reply.unavailable === true || typeof reply.message !== 'string' || !reply.message.trim() || !Array.isArray(reply.actions)) throw new Error('Resposta indisponível');
    if (reply.conversation) visit.conversation = reply.conversation;
    const suggestedDate = reply.draft?.date;
    if (suggestedDate && visit.details.date === payload.draft.date && !detailIssues({ ...visit.details, date: suggestedDate }).date) {
      visit.details.date = suggestedDate;
    }
    if (reply.brief) {
      const next=safeBrief(reply.brief);
      for(const [key,value] of Object.entries(next))if(JSON.stringify(visit.brief[key])===JSON.stringify(payload.brief[key]))visit.brief[key]=value;
    }

    const actions = Array.isArray(reply.actions) ? reply.actions : [];
    visit.chatMessages.push({
      role: 'assistant',
      text: reply.message || 'Aqui estão algumas sugestões frescas da nossa montra:',
      actions
    });
    visit.chatHistory = [
      ...visit.chatHistory,
      { role: 'user', text },
      { role: 'assistant', text: String(reply.message || '').slice(0, 600) }
    ].slice(-6);

    if (visit.unsent === text) visit.unsent = '';
    if (inputEl?.value.trim() === text) inputEl.value = '';
    if (statusEl) statusEl.textContent = T('');
    pendingRequest = null;
    persistVisit();
  } catch {
    if (statusEl) statusEl.textContent = '';
    if(handoffEl){handoffEl.innerHTML=faqBubbleHtml({ ask: text, answer: faqMatch(text) });handoffEl.hidden=false;}
    $('#chat-retry-btn').hidden = false;
  } finally {
    chatBusy = false;
    $('#chat-send-btn').disabled = false;
    if (statusEl && !visit.unsent) statusEl.textContent = T('');
    renderChatMessages();
  }
}

function orderIssues() {
  const issues = detailIssues(visit.details);
  if(sharedCart&&!sharedCart.ready)issues.cart='O pedido do website ainda não está confirmado. Aguarde um momento ou recarregue a página para rever as escolhas antes de continuar.';
  if (!basketSummary(visit.basket, catalogue).valid) issues.basket = 'Reveja os produtos ou formatos que já não estão disponíveis';
  if (visit.privateContextPending) issues.private = 'A conversa e os detalhes pessoais não são recuperados ao recarregar esta página. Reveja e volte a escrever o que a equipa precisa de saber antes de continuar.';
  return issues;
}

function computePreparedWhatsappMessage({ publicOnly = false } = {}) {
  try {
    // 26 Out 2026: a mensagem enviada leva zona, dedicatória, observações e detalhes da festa (decisão da dona).
    // Só as notas da conversa (preparedText) ficam fora do link.
    const base = orderMessage(visit.basket, catalogue, visit.details, visit.brief);
    const extra = publicOnly
      ? (visit.preparedText ? T('Tenho informação adicional para confirmar na conversa.') : '')
      : visit.preparedText || '';
    const party = (partyPlanner?.getDetails() || []).map(waBold).join('\n');
    const body = [party, extra].filter(Boolean).join('\n\n');
    if (!body) return base;
    const cut = base.lastIndexOf('\n\n');
    return cut > 0 ? [base.slice(0, cut), body, base.slice(cut + 2)].join('\n\n') : [base, body].join('\n\n');
  } catch {
    return '';
  }
}

function syncOrderValidationUI() {
  const issues = orderIssues();
  const issueList = Object.values(issues);
  const noticeEl = $('#order-validation-notice');
  const sendLink = $('#btn-whatsapp-send');
  if (noticeEl) {
    if (issueList.length > 0) {
      noticeEl.textContent = issueList.join(' · ');
      noticeEl.hidden = false;
    } else {
      noticeEl.textContent = T('');
      noticeEl.hidden = true;
    }
  }
  const reviewNotice = $('#order-review-issues');
  if (reviewNotice) { reviewNotice.hidden = !issueList.length; reviewNotice.textContent = issueList.join(' · '); }
  const copyButton = $('#btn-copy-message');
  if (copyButton) copyButton.disabled = issueList.length > 0;
  if (sendLink) {
    const blocked = issueList.length > 0;
    sendLink.classList.toggle('is-disabled-link', blocked);
    sendLink.setAttribute('aria-disabled', String(blocked));
  }
}

function refreshWhatsappPreviewInPlace() {
  const previewEl = $('#whatsapp-preview-text');
  const sendLink = $('#btn-whatsapp-send');
  const cardQuoteEl = $('#dedication-card-quote');
  const cardMetaEl = $('#dedication-card-meta');
  if (cardQuoteEl) {
    const rawNote = String(visit.details.dedication || '').trim();
    cardQuoteEl.textContent = rawNote || 'A mensagem que gostaria de dedicar…';
    cardQuoteEl.classList.toggle('is-placeholder', !rawNote);
  }
  if (cardMetaEl) {
    const dateLabel = visit.details.date ? `Para: ${waDate(visit.details.date, window.larrysaLang === 'en')}` : 'Data a combinar';
    cardMetaEl.textContent = T(`${dateLabel} · ${receptionLabels[visit.details.receive] || visit.details.receive}`);
  }
  syncOrderValidationUI();
  if (!previewEl || !sendLink) return;
  try {
    const msg = computePreparedWhatsappMessage();
    previewEl.value = msg;
    sendLink.href = sendLink.getAttribute('aria-disabled') === 'true' ? '#' : `https://wa.me/${window.LARRYSA_WA||''}?text=${encodeURIComponent(computePreparedWhatsappMessage({ publicOnly: true }))}`;
  } catch {}
}

function renderOrderDrawer() {
  const container = $('#order-container');
  if (!container) return;

  const sum = basketSummary(visit.basket, catalogue);
  const otherItems = sharedCart?.otherItemCount || 0;
  const websiteNotice = otherItems ? `<p role="status">${esc(T('Há produtos no seu carrinho que já não estão nesta montra. Estão preservados no website.'))} <a href="/cart">${esc(T('Rever pedido no website'))}</a></p>` : '';

  if (!visit.basket.length) {
    container.innerHTML = `
      ${websiteNotice}
      <div style="text-align:center;padding:28px 16px;background:var(--ex-glass);border:1px solid var(--line);border-radius:16px">
        <p class="eyebrow">O seu pedido</p>
        <h2 style="font:400 28px/1.1 var(--font-display);margin:0 0 8px">${otherItems ? esc(T("O seu pedido continua no website")) : esc(T("Ainda não escolheu o que vai para a mesa"))}</h2>
        <p style="color:var(--muted);margin:0 0 14px;font-size:13px">Descubra os bolos, salgados e sobremesas da nossa montra</p>
        <button type="button" class="primary" data-open-drawer="montra">Explorar a montra</button>
      </div>
    `;
    return;
  }

  const preparedMsg = computePreparedWhatsappMessage();
  const publicMsg = computePreparedWhatsappMessage({ publicOnly: true });
  const inBasketHandles = new Set(visit.basket.map((l) => l.product_handle));
  const pairingCandidates = ['croquetes-de-carne', 'rissois-de-camarao', 'mini-tarteletes', 'folhados-de-salsicha', 'rubra']
    .filter((h) => !inBasketHandles.has(h))
    .map((h) => getProduct(h))
    .filter(p => p && !(p.category === 'Bolos' && ['have','none'].includes(visit.brief.party?.cake)))
    .slice(0, 3);

  const targetGuests = Number(visit.brief?.people || 0);
  const capacity = computeTableGuestCapacity(sum.lines, targetGuests);
  const rawNote = String(visit.details.dedication || '').trim();
  const dateLabel = visit.details.date ? `Para: ${waDate(visit.details.date, window.larrysaLang === 'en')}` : 'Data a combinar';
  const upcomingDates = computeUpcomingDates();
  const issues = orderIssues();
  const issueList = Object.values(issues);

  // Ordenar visualmente: Bolos centrais primeiro, seguidos de Salgados e Sobremesas
  const visualPieces = [...sum.lines].sort((a, b) => {
    const pa = a.product || getProduct(a.product_handle);
    const pb = b.product || getProduct(b.product_handle);
    const rank = (p) => (p?.category === 'Bolos' ? 0 : p?.category === 'Salgados' ? 1 : 2);
    return rank(pa) - rank(pb);
  });

  container.innerHTML = `
    ${websiteNotice}
    <section class="order-marble-table-stage" id="order-marble-table" aria-label="Composição do seu pedido">
      <div class="order-marble-header">
        <div>
          <p class="eyebrow">Larrysa's Bakery · Pontinha</p>
          <h3>A mesa do seu pedido</h3>
        </div>
        <div class="order-table-capacity-pill confectionery-label" id="order-table-capacity">
          <strong>${esc(capacity.headline)}</strong>
          <small>${esc(capacity.detail)}</small>
        </div>
      </div>

      <div class="order-guest-simulator" role="group" aria-label="Convidados para esta encomenda">
        <span class="guest-sim-label">Quantos vão estar à mesa?</span>
        ${[8, 15, 25, 40]
          .map(
            (n) => `
            <button type="button" class="guest-sim-pill ${targetGuests === n ? 'is-active' : ''}" data-guest-target="${n}" aria-pressed="${targetGuests === n}">
              ${n} pessoas
            </button>
          `
          )
          .join('')}
        ${
          targetGuests > 0
            ? `<button type="button" class="guest-sim-clear" data-guest-target="0" title="Limpar número de convidados">✕</button>`
            : ''
        }
      </div>

      ${
        capacity.recommendation
          ? `
          <div class="guest-sim-advice is-${esc(capacity.recommendation.status)}" role="status">
            <span>${esc(capacity.recommendation.text)}</span>
            ${
              capacity.recommendation.suggestHandle
                ? `<button type="button" class="guest-sim-add-btn" data-order-quick-add="${esc(capacity.recommendation.suggestHandle)}">${esc(capacity.recommendation.suggestLabel)}</button>`
                : ''
            }
          </div>
        `
          : ''
      }

      <div class="order-marble-surface">
        ${visualPieces
          .map((l) => {
            const p = l.product || getProduct(l.product_handle);
            const isCake = p?.category === 'Bolos';
            const vTitle = l.variant && !/^Default(?: Title)?$/i.test(l.variant.title) ? l.variant.title : '';
            return `
              <button type="button" class="marble-table-piece ${isCake ? 'is-centerpiece-cake' : 'is-side-platter'}" data-inspect-on-counter="${esc(p?.handle || l.product_handle)}" title="Ver ${esc(p?.name || '')} no balcão">
                <span class="marble-piece-figure">
                  ${p?.displayLargeResolved || p?.displayImageResolved ? `<img src="${esc(p.displayLargeResolved || p.displayImageResolved)}" alt="${esc(p.name)}" />` : ''}
                  <span class="marble-piece-shadow" aria-hidden="true"></span>
                  ${l.quantity > 1 ? `<span class="marble-piece-qty">${l.quantity}×</span>` : ''}
                </span>
                <span class="marble-piece-label">
                  <strong>${esc(p?.name || l.product_handle)}</strong>
                  ${vTitle ? `<small>${esc(vTitle)}</small>` : `<small>${esc(p?.category || '')}</small>`}
                </span>
              </button>
            `;
          })
          .join('')}
      </div>
    </section>

    <div class="order-layout">
      <div class="order-lines-col">
        <p class="eyebrow">As suas escolhas</p>
        <h2>Pedido (${visit.basket.length} ${visit.basket.length === 1 ? 'produto' : 'produtos'})</h2>
        <div id="basket-lines-list">
          ${sum.lines
            .map((l) => {
              const p = l.product || getProduct(l.product_handle);
              const vTitle = l.variant && !/^Default(?: Title)?$/i.test(l.variant.title) ? l.variant.title : 'Por unidade';
              return `
                <article class="order-line-item">
                  ${p?.displayImageResolved ? `<img src="${esc(p.displayImageResolved)}" alt="${esc(p.name)}" />` : '<span aria-hidden="true"></span>'}
                  <div>
                    <h3>${esc(p?.name || l.product_handle)}</h3>
                    <div class="order-line-meta">${esc(vTitle)} · <strong>${money(l.total)}</strong>${l.valid&&l.unitCount&&l.quantity>1?` · ${l.unitCount} unidades no total`:``}${!l.valid ? '<p role="status">Esta escolha precisa de revisão. Troque o formato ou remova-a.</p>' : ''}</div>
                    <div class="order-line-controls">
                      <label class="sr-only" for="qty-${esc(l.id)}">Quantidade de ${esc(p?.name || '')}</label>
                      <input id="qty-${esc(l.id)}" type="number" min="1" max="99" step="1" value="${l.quantity}" data-line-quantity="${esc(l.id)}" aria-label="Quantidade de ${esc(p?.name || '')}">
                      <button type="button" class="text-button" data-basket-swap="${esc(l.id)}">Trocar</button>
                      <button type="button" class="text-button" data-basket-remove="${esc(l.id)}">Remover</button>
                    </div>
                  </div>
                </article>
              `;
            })
            .join('')}
        </div>
        <div class="order-subtotal-box">
          <span>Valor base</span>
          <strong id="basket-subtotal">${money(sum.total)}</strong>
        </div>

        ${
          pairingCandidates.length
            ? `
          <div class="order-pairing-box">
            <p class="eyebrow">Para completar a mesa</p>
            <div class="order-pairing-row">
              ${pairingCandidates
                .map(
                  (cp) => `
                  <button type="button" class="pairing-chip" data-order-quick-add="${esc(cp.handle)}">
                    <img src="${esc(cp.displayImageResolved)}" alt="${esc(cp.name)}" />
                    <span>
                      <strong>${cp.variants.length > 1 ? '' : '+ '}${esc(cp.name)}</strong>
                      <small>${cp.variants.length > 1 ? 'Escolher formato · ' : ''}${esc(cp.priceLabel)}</small>
                    </span>
                  </button>
                `
                )
                .join('')}
            </div>
          </div>
        `
            : ''
        }

        <button type="button" class="text-button" style="margin-top:6px" data-open-drawer="montra" data-clear-swap>+ Explorar a montra</button>
      </div>

      <div class="order-details-col">
        <h2>Os detalhes do pedido</h2>
        ${visit.brief.party?.active ? '<button type="button" class="text-button" data-open-party-planner>Rever o plano da festa</button>' : ''}
        <div class="order-form-grid">
          <div class="order-field">
            <label for="order-date">Para quando precisa?</label>
            <input type="date" id="order-date" min="${today()}" value="${esc(visit.details.date)}" aria-describedby="order-sunday-note order-hours-note">
            <p class="order-sunday-note" id="order-sunday-note" role="status" ${isSunday(visit.details.date) ? '' : 'hidden'}>Ao domingo só recebemos encomendas. Vamos combinar consigo a melhor hora de recolha.</p>
            <div class="date-quick-chips" role="group" aria-label="Datas rápidas">
              ${upcomingDates
                .map(
                  (d) => `
                  <button type="button" class="date-quick-chip ${visit.details.date === d.value ? 'is-active' : ''}" data-date-preset="${esc(d.value)}">
                    ${esc(d.label)}
                  </button>
                `
                )
                .join('')}
            </div>
          </div>
          <div class="order-field">
            <label>Recolha</label>
            <p class="order-receive-note"><strong>Recolha gratuita na Pontinha.</strong> Se enviar alguém (por exemplo, um estafeta), o transporte e o cuidado com o bolo ficam a seu cargo a partir da recolha.</p>
          </div>
        </div>
        <div class="order-rules">
          <p class="order-rule" id="order-hours-note"><strong>Horário:</strong> de segunda a sábado, das 8h às 22h. Ao domingo só recebemos encomendas. Diga-nos para quando precisa e combinamos consigo o dia e a hora de recolha.</p>
          <p class="order-rule"><strong>Sinal de 50%:</strong> depois de confirmarmos a disponibilidade no WhatsApp, pedimos um sinal de 50% para reservar a sua encomenda. O restante paga na recolha.</p>
        </div>
        <div class="order-field">
          <label for="order-allergies">Alergias ou intolerâncias</label>
          <textarea id="order-allergies" rows="2" maxlength="300" placeholder="Ex.: sem frutos secos. Se não houver, escreva «Não»." aria-describedby="order-allergies-help">${esc(visit.details.allergies || '')}</textarea>
          <p class="order-allergies-help" id="order-allergies-help">Não publicamos ingredientes nem alergénios por produto. <a href="${esc(askAllergyHref())}" target="_blank" rel="noopener" data-wa-keep data-wa-ask-allergy>Pergunte-nos antes de encomendar</a>.</p>
        </div>


        <p id="order-validation-notice" class="order-validation-notice" role="alert" ${issueList.length ? '' : 'hidden'}>
          ${esc(issueList.join(' · '))}
        </p>

        ${sum.lines.some(l => l.product?.category === 'Bolos') || rawNote ? `
        <div class="order-field">
          <label for="order-dedication">Mensagem ou dedicatória pretendida (opcional)</label>
          <textarea id="order-dedication" rows="2" maxlength="500" placeholder="Ex.: Parabéns, Mãe!">${esc(visit.details.dedication || '')}</textarea>
          <div class="dedication-quick-chips" aria-label="Sugestões rápidas de dedicatória">
            <button type="button" class="dedication-chip" data-dedication-preset="Parabéns! Que seja um dia muito doce e feliz">«Parabéns! Dia feliz»</button>
            <button type="button" class="dedication-chip" data-dedication-preset="Feliz Aniversário! Celebramos consigo à mesa">«Feliz Aniversário»</button>
            <button type="button" class="dedication-chip" data-dedication-preset="Com todo o carinho, para partilhar em família">«Com todo o carinho»</button>
          </div>
        </div>

        <aside class="dedication-card-preview" id="dedication-card-preview" aria-label="Dedicatória pretendida">
          <div class="dedication-card-inner">
            <span class="dedication-card-seal">LARRYSA’S BAKERY · PONTINHA</span>
            <p class="dedication-card-quote ${rawNote ? '' : 'is-placeholder'}" id="dedication-card-quote">
              ${esc(rawNote || 'A mensagem que gostaria de dedicar…')}
            </p>
            <span class="dedication-card-meta" id="dedication-card-meta">${esc(dateLabel)} · ${esc(receptionLabels[visit.details.receive] || visit.details.receive)}</span>
          </div>
        </aside>` : ''}

        ${visit.privateContextPending ? '<button type="button" class="btn-secondary" data-review-private-context>Já revi os detalhes do pedido</button>' : ''}
        <div class="order-field"><label for="order-note">Observações para a equipa (opcional)</label><textarea id="order-note" rows="2" maxlength="1000" placeholder="Outros detalhes a combinar com a equipa">${esc(visit.details.note || '')}</textarea></div>
        ${sum.lines.some(l => l.product?.category === 'Bolos') || rawNote ? '<p class="order-privacy-note">A aplicação da dedicatória no bolo ou num cartão é confirmada pela equipa.</p>' : ''}
      </div>
    </div>
    <div class="whatsapp-handoff-box">
          <p class="order-privacy-note">A mensagem leva os produtos, as quantidades, para quando precisa, as alergias, a dedicatória e as observações. Só tem de a enviar no WhatsApp. A encomenda fica reservada depois de confirmarmos e do sinal de 50%.</p>
          <div class="order-field">
            <details class="order-extra-message" ${visit.preparedText ? 'open' : ''}><summary>Acrescentar uma mensagem (opcional)</summary>
            <label class="sr-only" for="order-additional-message">Mensagem adicional para a equipa</label>
            <textarea id="order-additional-message" rows="2" maxlength="600">${esc(visit.preparedText || '')}</textarea></details>
            <details class="order-message-preview order-final-review" id="order-final-review">
              <summary>Rever o pedido</summary>
              <p id="order-review-issues" role="alert" ${issueList.length ? '' : 'hidden'}>${esc(issueList.join(' · '))}</p>
              <p class="order-review-state">Pedido preparado · ainda não confirmado</p>
              <h3>Está tudo como pretende?</h3>
              <p>Reveja as escolhas e os detalhes abaixo. A encomenda só fica confirmada depois da resposta expressa da equipa no WhatsApp.</p>
              <label class="sr-only" for="whatsapp-preview-text">Mensagem preparada para a equipa</label>
              <textarea id="whatsapp-preview-text" rows="18" readonly>${esc(preparedMsg)}</textarea>
              <p>O valor final e eventuais extras são confirmados pela equipa.</p>
              <button type="button" class="text-button" data-edit-order>Editar os detalhes</button>
          <div class="whatsapp-actions">
            <button type="button" class="btn-secondary" id="btn-copy-message" ${issueList.length ? 'disabled' : ''}>1. Copiar mensagem completa</button>
            <a class="btn-primary ${issueList.length ? 'is-disabled-link' : ''}" id="btn-whatsapp-send" aria-disabled="${Boolean(issueList.length)}" target="_blank" rel="noopener" href="${issueList.length ? '#' : 'https://wa.me/' + (window.LARRYSA_WA||'') + '?text=' + encodeURIComponent(publicMsg)}">
              2. Continuar no WhatsApp ↗
            </a>
          </div>
            </details>
            <button type="button" class="text-button" data-human-handoff>Pedir esclarecimentos à equipa</button>
          </div>
        </div>
  `;
}

let partyPlanner, plannerScript;
async function openPartyPlanner(){
  openDrawer('festa');
  const root=$('#party-planner');
  try{
    if(!window.LarrysaPlannerV1){
      plannerScript ||= new Promise((resolve,reject)=>{const script=document.createElement('script');script.src=new URL("./lh-9925616a-festa-planner-v1.js?v=a3d61a7ccb8d",import.meta.url).href;script.onload=resolve;script.onerror=()=>{script.remove();plannerScript=null;reject(Error('planner_unavailable'));};document.head.append(script);});
      await plannerScript;
    }
    const p=visit.brief.party||{};
    const cakes=basketSummary(visit.basket,catalogue).lines.filter(l=>l.valid&&l.product?.category==='Bolos');
    const context={...(visit.brief.people?{people:String(visit.brief.people)}:{}),event:p.event,cakeChoice:p.cake,components:p.components,foodRole:p.foodRole,...(visit.details.date?{date:visit.details.date}:{}),reception:'levantamento',...(!['have','none','undecided'].includes(p.cake)&&cakes.length?{selectedCake:cakes.map(l=>l.product.name).join(', ')}:{})};
    if(partyPlanner){partyPlanner.refresh(context);return;}
    const products=catalogue.map(product=>({handle:product.handle,title:product.name,image:productPhotos(product)[0]?.src||'',published:true,available:product.variants.some(v=>v.available),collection:{Bolos:'bolos',Salgados:'salgados',Sobremesas:'sobremesas'}[product.category],variants:product.variants.map(v=>({id:v.id,title:v.title,available:v.available,priceCents:v.price}))}));
    let savedPartyPlan=null;try{savedPartyPlan=JSON.parse(sessionStorage.getItem('larrysa:party-plan:v1')||'null');}catch{}
    partyPlanner=window.LarrysaPlannerV1.createPlanner(root,products,{
      savedPlan:savedPartyPlan,
      savePlan:state=>{try{sessionStorage.setItem('larrysa:party-plan:v1',JSON.stringify(state));return true;}catch{return false;}},
      referenceImage:new URL('./bakery-party-reference.webp',import.meta.url).href,
      hasCake:()=>basketSummary(visit.basket,catalogue).lines.some(l=>l.product?.category==='Bolos'),
      getSelection:()=>partySelection(visit.basket,catalogue),
      onChange:context=>{
        const party=cleanParty({active:true,...(context.event?{event:context.event}:{}),...(context.cakeChoice?{cake:context.cakeChoice}:{}),components:context.components,...(context.foodRole?{foodRole:context.foodRole}:{}),...(visit.brief.party?.asked?{asked:true}:{})});
        if(party){visit.brief.party=party;if(party.event)delete visit.brief.occasion;}
        const people=Number(context.people);if(Number.isSafeInteger(people)&&people>0&&people<=500)visit.brief.people=people;else if(!context.people)delete visit.brief.people;
        if(!detailIssues({...visit.details,date:context.date}).date)visit.details.date=context.date;
        visit.details.receive='Recolha na Pontinha';
        persistVisit();
      }
    },context);
  }catch{root.innerHTML='<p role="alert">Não foi possível abrir o planeador. A conversa e o pedido continuam guardados neste separador.</p><button type="button" data-open-party-planner>Tentar novamente</button><button type="button" data-human-handoff>Rever o pedido</button>';}
}

function openDrawer(viewName) {
  pauseBakeryStory();
  if (viewName !== 'montra') replaceLineId = null;
  setPanelExpanded(true);
  // Garantir que estamos no modo sala para ver o painel
  if (scene3d && scene3d.activeMode !== 'room') {
    activeStation = 'loja';
    scene3d.goToStation('loja');
    const retBar = $('#station-return-bar');
    if (retBar) retBar.hidden = true;
    renderVitrinaStrip();
  }

  const drawer = $('#store-drawer');
  if (!drawer) return;
  if (drawer.hidden) drawerOpener = document.activeElement;
  drawer.hidden = false;
  $('#panel-content').scrollTop = 0;
  document.body.dataset.drawer = viewName;
  syncStageLabel();
  ['panel-view-menu', 'welcome-card', 'counter-product-card'].forEach(id => {
    const el = document.getElementById(id);
    el.inert = true; el.hidden = true; el.setAttribute('aria-hidden', 'true');
  });

  const views = {
    montra: $('#drawer-view-montra'),
    ajuda: $('#drawer-view-ajuda'),
    pedido: $('#drawer-view-pedido'),
    comunidade: $('#drawer-view-comunidade'),
    festa: $('#drawer-view-festa')
  };
  Object.entries(views).forEach(([k, el]) => {
    if (el) el.hidden = k !== viewName;
  });

  $$('[data-drawer-tab]').forEach((btn) => {
    btn.classList.toggle('is-active', btn.dataset.drawerTab === viewName);
  });

  $$('.journey li').forEach((li) => {
    const isPedido = viewName === 'pedido';
    if ((isPedido && li.dataset.journeyStep === 'rever') || (!isPedido && li.dataset.journeyStep === 'escolher')) {
      li.setAttribute('aria-current', 'step');
    } else {
      li.removeAttribute('aria-current');
    }
  });

  if (viewName === 'montra') {
    $$('[data-filter-cat]').forEach(b => { b.classList.toggle('is-active', b.dataset.filterCat === activeCategoryFilter); b.setAttribute('aria-pressed', String(b.dataset.filterCat === activeCategoryFilter)); });
    $('#montra-search').value = searchQuery;
    renderMontraGrid();
  }
  if (viewName === 'ajuda') { renderChatMessages(); $('#chat-input').value = visit.unsent || ''; $('#chat-retry-btn').hidden = !(pendingRequest || (visit.unsent && visit.chatMessages.at(-1)?.role === 'user')); }
  if (viewName === 'pedido') renderOrderDrawer();
  if (viewName === 'comunidade') {
    startBakeryGallery();
    $$('#drawer-view-comunidade video[data-kitchen-video]').forEach((vEl) => {
      hydrateVideoElement(vEl, vEl.dataset.kitchenVideo, vEl.getAttribute('poster') || '');
    });
  }
  const focusTarget = viewName === 'ajuda' ? $('#chat-input') : views[viewName]?.querySelector('h1,h2,input,button,a');
  if (focusTarget) {
    if (/^H[12]$/.test(focusTarget.tagName)) focusTarget.setAttribute('tabindex', '-1');
    focusTarget.focus({ preventScroll: true });
  }
}

function syncStageLabel() {
  const labels = {welcome:'Larrysa\'s Bakery · Pontinha',menu:'A nossa montra',product:'O produto em detalhe',montra:'A nossa montra',ajuda:'Dúvidas? Fale connosco',pedido:'O seu pedido',comunidade:'A nossa Bakery',festa:'O plano da sua festa'};
  const label = $('#stage-label');
  if (label) label.textContent = labels[document.body.dataset.drawer || currentPanelView] || 'A nossa montra';
  syncPanelNavigation();
}

function closeDrawer() {
  pauseBakeryStory();
  [['panel-view-menu','menu'], ['welcome-card','welcome'], ['counter-product-card','product']].forEach(([id,view]) => {
    const el = document.getElementById(id), hidden = view !== currentPanelView;
    el.inert = hidden; el.hidden = hidden; el.setAttribute('aria-hidden', String(hidden));
  });
  delete document.body.dataset.drawer;
  syncStageLabel();
  const drawer = $('#store-drawer');
  if (drawer) drawer.hidden = true;
  if (drawerOpener?.isConnected) drawerOpener.focus({ preventScroll: true });
}

function openPhotoModal(handle) {
  const p = getProduct(handle || selectedHandle);
  if (!p) return;
  photoHandle = p.handle;
  photoOpener = document.activeElement;
  photoReturnToCompare = Boolean($('#compare-modal').open);
  if (photoReturnToCompare) $('#compare-modal').close();
  const modal = $('#photo-modal');
  if (!modal) return;

  $('#pm-category').textContent = T(`${p.category} · Fotografia original`);
  $('#pm-title').textContent = p.name;
  const img = $('#pm-image');
  if (img) {
    img.src = p.originalImageResolved;
    img.alt = `${p.name} · Fotografia original completa sem recorte`;
  }
  const vp = $('#pm-viewport');
  if (vp) vp.classList.remove('is-zoomed');
  const zoomBtn = $('#pm-toggle-zoom');
  if (zoomBtn) zoomBtn.textContent = T('Ampliar detalhes');

  $('#pm-caption').textContent =
    p.photoNote || '';

  showModalPhoto(p.handle === selectedHandle ? galleryIndex : 0);
  $('#pm-nav').hidden = productPhotos(p).length < 2;
  modal.showModal();
}

function renderCompareModal() {
  const body = $('#compare-stage-body');
  if (!body) return;
  const pool = catalogue.filter((p) => p.category === compareCategory);
  const selected = new Set([compareLeftHandle, compareRightHandle]);
  const items = catalogue.filter(p => p.category === compareCategory || selected.has(p.handle));
  if (items.length < 2) return;

  let leftProd = items.find((c) => c.handle === compareLeftHandle) || items[0];
  let rightProd = items.find((c) => c.handle === compareRightHandle && c.handle !== leftProd.handle);
  if (!rightProd) {
    rightProd = items.find((c) => c.handle !== leftProd.handle) || items[1];
  }
  compareLeftHandle = leftProd.handle;
  compareRightHandle = rightProd.handle;

  const renderCompareColumn = (p, side) => {
    const layers = getRecipeLayers(p);
    const fp = p.foodPornMedia;
    const chosenVar = getSelectedVariant(p);
    const effectivePrice = chosenVar ? money(chosenVar.price) : p.priceLabel;
    return `
      <article class="compare-cake-col" data-compare-col="${side}">
        <div class="compare-selector-bar">
          <label for="compare-select-${side}">${side === 'left' ? 'Primeira opção' : 'Segunda opção'}</label>
          <select id="compare-select-${side}" data-compare-select="${side}">
            ${items
              .map(
                (c) => `
                <option value="${esc(c.handle)}" ${c.handle === p.handle ? 'selected' : ''}>
                  ${esc(c.name)} · ${esc(c.priceLabel)}
                </option>
              `
              )
              .join('')}
          </select>
        </div>

        <div class="compare-marble-pedestal">
          <div class="compare-figure-wrap">
            <img src="${esc(p.displayLargeResolved || p.displayImageResolved)}" alt="${esc(p.name)}" />
            <span class="compare-contact-shadow" aria-hidden="true"></span>
          </div>
          <div class="compare-plaque confectionery-label">
            <strong>${esc(p.name)}</strong>
            <small>${esc(T(compactDesc(p)))}</small>
            <em>${esc(effectivePrice)}</em>
          </div>
        </div>

        ${
          p.variants.length > 1
            ? `
            <div class="compare-variant-bar">
              <label for="compare-var-${side}">Formato:</label>
              <select id="compare-var-${side}" data-compare-variant="${esc(p.handle)}">
                ${p.variants
                  .map(
                    (v) => `
                    <option value="${v.id}" ${chosenVar?.id === v.id ? 'selected' : ''}>
                      ${esc(T(v.title))} · ${money(v.price)}
                    </option>
                  `
                  )
                  .join('')}
              </select>
            </div>
          `
            : ''
        }

        <div class="compare-specs">
          <div class="recipe-layers-strip" aria-label="Camadas reais de ${esc(p.name)}">
            ${layers.map((layer, idx) => `<span class="recipe-layer-pill"><small>${idx + 1}</small> ${esc(layer)}</span>`).join('')}
          </div>
          <p class="compare-serving-note">${esc(getServingAndKitchenNote(p))}</p>
          <p class="compare-conservation-note">${esc(getConservationAndServingNote(p))}</p>
          ${fp ? `<p class="compare-video-note">${esc(fp.caption)}</p>` : ''}
        </div>

        <div class="compare-col-actions">
          <button type="button" class="primary" data-compare-choose="${esc(p.handle)}">
            + Escolher ${esc(p.name)} (${esc(effectivePrice)})
          </button>
          <button type="button" class="secondary" data-vitrina-open-photo="${esc(p.handle)}">
            Fotografia original ↗
          </button>
        </div>
      </article>
    `;
  };

  const quickPairsByCat = {
    Bolos: [
      { pair: 'rubra:cascata-de-ninho', label: 'Rubra vs Cascata de Ninho' },
      { pair: 'flor-citrica:beijo-de-coco', label: 'Flor Cítrica vs Beijo de Coco' },
      { pair: 'rubra:flor-citrica', label: 'Rubra vs Flor Cítrica' }
    ],
    Sobremesas: [
      { pair: 'mini-tarteletes:argola-dourada', label: 'Mini-tarteletes vs Argola Dourada' },
      { pair: 'cheesecake-de-frutos-vermelhos:o-pudim', label: 'Cheesecake vs Pudim' }
    ],
    Salgados: [
      { pair: 'croquetes-de-carne:rissois-de-camarao', label: 'Croquetes vs Rissóis de Camarão' },
      { pair: 'folar-da-casa:tranca-folhada-mista', label: 'Folar da Casa vs Trança Folhada' }
    ]
  };
  const activePairs = (quickPairsByCat[compareCategory] || quickPairsByCat.Bolos).filter(({pair}) => pair.split(':').every(handle => pool.some(p => p.handle === handle)));

  body.innerHTML = `
    <div class="compare-top-controls">
      <div class="compare-cat-tabs" role="tablist" aria-label="Categoria a comparar no balcão">
        ${categories
          .map(
            (cat) => `
            <button type="button" class="compare-cat-tab ${compareCategory === cat ? 'is-active' : ''}" data-compare-cat="${cat}">
              ${cat} (${catalogue.filter((p) => p.category === cat).length})
            </button>
          `
          )
          .join('')}
      </div>
      <div class="compare-quick-pairs" role="group" aria-label="Comparações sugeridas">
        <span>Comparações sugeridas:</span>
        ${activePairs
          .map(
            (qp) => `<button type="button" class="compare-pair-pill" data-compare-pair="${esc(qp.pair)}">${esc(qp.label)}</button>`
          )
          .join('')}
      </div>
    </div>
    <div class="compare-columns-grid">
      ${renderCompareColumn(leftProd, 'left')}
      ${renderCompareColumn(rightProd, 'right')}
    </div>
  `;
  [leftProd,rightProd].forEach((p,i) => framePhotograph(body.querySelectorAll('.compare-figure-wrap img')[i],p));
}

function openCompareModal(initialHandle = null) {
  const modal = $('#compare-modal');
  if (!modal) return;
  const focusHandle = initialHandle || selectedHandle || 'rubra';
  const focusProd = getProduct(focusHandle);
  if (focusProd && ['Bolos', 'Sobremesas', 'Salgados'].includes(focusProd.category)) {
    compareCategory = focusProd.category;
    compareLeftHandle = focusProd.handle;
  }
  const pool = catalogue.filter((p) => p.category === compareCategory);
  if (!pool.some((p) => p.handle === compareRightHandle) || compareRightHandle === compareLeftHandle) {
    const fallbackRight = pool.find((p) => p.handle !== compareLeftHandle);
    if (fallbackRight) compareRightHandle = fallbackRight.handle;
  }
  renderCompareModal();
  if (!modal.open) modal.showModal();
  playPorcelainChime(523.25);
}

function exitVitrinaIfActive() {
  if (activeStation === 'bolos' || activeStation === 'salgados') {
    activeStation = 'loja';
    const retBar = $('#station-return-bar');
    if (retBar) retBar.hidden = true;
    renderVitrinaStrip();
  }
}

function setupUIEvents() {
  document.addEventListener('click', e => { if (e.target.closest('[data-human-handoff]')) { e.preventDefault(); openHumanHandoff(); } });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !$('#store-drawer').hidden && !$('#photo-modal').open && !$('#compare-modal').open) {
      event.preventDefault();
      replaceLineId = null;
      closeDrawer();
    }
  });
  $('#chat-input')?.addEventListener('input', e => { visit.unsent = e.target.value; persistVisit(); });
  $('#chat-retry-btn')?.addEventListener('click', () => sendMessageToLarrysa(visit.unsent, { retry: true }));
  $('#drawer-save-retry')?.addEventListener('click', () => persistVisit({ immediate: true }));

  // Seletor de direção artística (Atelier de Cacau / Herbário à Mesa)
  $('#direction-select')?.addEventListener('change', (e) => {
    const dir = e.target.value === 'herbario' ? 'herbario' : 'cacau';
    document.documentElement.dataset.direction = dir;
    document.documentElement.dataset.exhibition = dir;
    saveUIPrefs({ direction: dir });
    if (scene3d) scene3d.setDirection(dir);
    playPorcelainChime(587.33);
  });

  // Seletor de Luz Viva da Pontinha (Manhã de Fornada / Balcão 2700K / Noite na Pontinha)
  $('#lighting-select')?.addEventListener('change', (e) => {
    const mood = ['manha', 'tarde', 'noite'].includes(e.target.value) ? e.target.value : 'tarde';
    document.documentElement.dataset.lighting = mood;
    saveUIPrefs({ lighting: mood });
    syncOvenTicker(mood);
    if (scene3d) scene3d.setLightingMood(mood);
    if (activeStation === 'bolos' || activeStation === 'salgados') {
      renderVitrinaStrip();
    }
    const labels = {
      manha: 'Luz da manhã na Pontinha',
      tarde: 'Luz quente de balcão',
      noite: 'Luz intimista de noite na Pontinha'
    };
    showToast(labels[mood] || labels.tarde);
    playPorcelainChime(659.25);
  });

  // Botão Som da Loja (Opt-In)
  $('#sound-toggle-btn')?.addEventListener('click', () => {
    toggleBakerySound();
  });

  // Fechar modal de comparação lado a lado
  $('#compare-close')?.addEventListener('click', () => {
    $('#compare-modal')?.close();
  });

  $('#panel-distance')?.addEventListener('click', () => {
    exitVitrinaIfActive();
    if (document.body.classList.contains('entrance-proof') && document.body.classList.contains('mobile-panel-expanded')) {
      setPanelView('welcome'); $('#panel-back-btn')?.focus({preventScroll:true}); return;
    }
    setPanelExpanded(!document.body.classList.contains('mobile-panel-expanded'));
  });
  $('#cp-image').addEventListener('error', () => { $('#cp-photo-error').hidden = false; });
  $('#cp-image').addEventListener('load', () => { $('#cp-photo-error').hidden = true; });
  $('#cp-photo-retry').addEventListener('click', () => { $('#cp-image').src = $('#cp-image').src; });
  $('#photo-modal').addEventListener('close', () => { if (photoReturnToCompare) { photoReturnToCompare = false; $('#compare-modal').showModal(); photoOpener?.focus({preventScroll:true}); } });
  $('#cp-photo-prev').addEventListener('click', () => showProductPhoto(galleryIndex - 1));
  $('#cp-photo-next').addEventListener('click', () => showProductPhoto(galleryIndex + 1));
  $('#pm-prev').addEventListener('click', () => showModalPhoto(photoIndex - 1));
  $('#pm-next').addEventListener('click', () => showModalPhoto(photoIndex + 1));
  $('#cp-photo-thumbs').addEventListener('click', event => { const b = event.target.closest('[data-product-photo]'); if (b) showProductPhoto(Number(b.dataset.productPhoto)); });
  $('#photo-modal').addEventListener('keydown', event => { if (['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); showModalPhoto(photoIndex + (event.key === 'ArrowRight' ? 1 : -1)); } });
  let touchStart = null;
  $('#cp-zoom-btn').addEventListener('touchstart', event => { touchStart = event.touches.length === 1 ? [event.touches[0].clientX, event.touches[0].clientY] : null; }, {passive: true});
  $('#cp-zoom-btn').addEventListener('touchend', event => { if (!touchStart || !event.changedTouches.length) return; const dx = event.changedTouches[0].clientX - touchStart[0], dy = event.changedTouches[0].clientY - touchStart[1]; touchStart = null; if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) { showProductPhoto(galleryIndex + (dx < 0 ? 1 : -1)); } }, {passive: true});

  // Alternar vídeo de textura ao vivo no Hero (#hero-video-toggle) e na Ficha de Produto (#cp-video-toggle)
  $('#hero-video-toggle')?.addEventListener('click', (e) => {
    e.stopPropagation();
    heroVideoActive = !heroVideoActive;
    const p = getProduct(selectedHandle);
    if (p) syncHeroMedia(p);
  });

  $('#cp-video-toggle')?.addEventListener('click', (e) => {
    e.stopPropagation();
    cpVideoActive = !cpVideoActive;
    openCounterProductCard(selectedHandle);
  });

  // Cliques nos 4 bolos em destaque na barra .display-grid
  $$('[data-featured-cake]').forEach((card) => {
    card.addEventListener('click', () => {
      const handle = card.dataset.featuredCake;
      if (selectedHandle === handle) {
        openCounterProductCard(handle);
      } else {
        previewFeaturedCakeInHero(handle);
      }
    });
  });

  // Botão e foto do Hero em #panel-view-menu
  $('#hero-open-product')?.addEventListener('click', (e) => {
    const handle = e.currentTarget.dataset.selectProduct || selectedHandle;
    openCounterProductCard(handle);
  });
  $('#hero-photo-trigger')?.addEventListener('click', () => {
    openCounterProductCard(selectedHandle);
  });

  // Botões [data-panel-view], [data-select-product], [data-open-compare] e interações da Vitrina Real (#vitrina-strip)
  document.addEventListener('click', (e) => {
    const comparePairBtn = e.target.closest('[data-compare-pair]');
    if (comparePairBtn) {
      const [l, r] = (comparePairBtn.dataset.comparePair || '').split(':');
      if (l && r) {
        const lp = getProduct(l);
        if (lp?.category) compareCategory = lp.category;
        compareLeftHandle = l;
        compareRightHandle = r;
        const modal = $('#compare-modal');
        renderCompareModal();
        if (modal && !modal.open) modal.showModal();
        playPorcelainChime(587.33);
      }
      return;
    }
    const compareCatBtn = e.target.closest('[data-compare-cat]');
    if (compareCatBtn) {
      const cat = compareCatBtn.dataset.compareCat;
      if (['Bolos', 'Sobremesas', 'Salgados'].includes(cat)) {
        compareCategory = cat;
        const pool = catalogue.filter((p) => p.category === cat);
        if (pool.length >= 2) {
          compareLeftHandle = pool[0].handle;
          compareRightHandle = pool[1].handle;
        }
        renderCompareModal();
        playPorcelainChime(587.33);
      }
      return;
    }
    const openCompareBtn = e.target.closest('[data-open-compare]');
    if (openCompareBtn) {
      const h = openCompareBtn.getAttribute('data-open-compare') || selectedHandle;
      openCompareModal(h);
      return;
    }
    const compareChooseBtn = e.target.closest('[data-compare-choose]');
    if (compareChooseBtn) {
      const h = compareChooseBtn.dataset.compareChoose;
      $('#compare-modal')?.close();
      addCurrentProductToBasket(h, 1);
      playPorcelainChime(659.25);
      return;
    }
    const swatchVarBtn = e.target.closest('[data-cp-swatch-variant]');
    if (swatchVarBtn) {
      selectedVariants[selectedHandle] = Number(swatchVarBtn.dataset.cpSwatchVariant);
      openCounterProductCard(selectedHandle);
      playPorcelainChime(587.33);
      return;
    }
    const tasteChipBtn = e.target.closest('[data-taste-filter]');
    if (tasteChipBtn) {
      const term = tasteChipBtn.dataset.tasteFilter || '';
      activeTasteFilter = term;
      searchQuery = '';
      const searchInput = $('#montra-search');
      if (searchInput) searchInput.value = '';
      $$('[data-taste-filter]').forEach((b) => b.classList.toggle('is-active', b === tasteChipBtn && Boolean(term)));
      renderMontraGrid();
      return;
    }
    const vitrinaMediaToggle = e.target.closest('[data-vitrina-toggle-media]');
    if (vitrinaMediaToggle) {
      vitrinaVideoActive = !vitrinaVideoActive;
      renderVitrinaStrip();
      return;
    }
    const spotSelectBtn = e.target.closest('[data-vitrina-spot]');
    if (spotSelectBtn) {
      selectedHandle = spotSelectBtn.dataset.vitrinaSpot;
      visit.viewed = selectedHandle;
      renderVitrinaStrip();
      playPorcelainChime(587.33);
      return;
    }
    const spotAddBtn = e.target.closest('[data-vitrina-spot-add]');
    if (spotAddBtn) {
      addCurrentProductToBasket(spotAddBtn.dataset.vitrinaSpotAdd, 1);
      playPorcelainChime(659.25);
      return;
    }
    const vitrinaPhotoBtn = e.target.closest('[data-vitrina-open-photo]');
    if (vitrinaPhotoBtn) {
      openPhotoModal(vitrinaPhotoBtn.dataset.vitrinaOpenPhoto);
      return;
    }
    const vitrinaAskBtn = e.target.closest('[data-vitrina-ask]');
    if (vitrinaAskBtn) {
      const p = getProduct(vitrinaAskBtn.dataset.vitrinaAsk);
      if (scene3d && scene3d.activeMode !== 'room') {
        activeStation = 'loja';
        scene3d.goToStation('loja');
        const retBar = $('#station-return-bar');
        if (retBar) retBar.hidden = true;
        renderVitrinaStrip();
      }
      openDrawer('ajuda');
      if (p) {
        sendMessageToLarrysa(`Como é o ${p.name}? Combina bem com uma celebração?`);
      }
      return;
    }
    const quickAddBtn = e.target.closest('[data-vitrina-quick-add]');
    if (quickAddBtn) {
      addCurrentProductToBasket(quickAddBtn.dataset.vitrinaQuickAdd, 1);
      playPorcelainChime(659.25);
      return;
    }
    const cancelSwapBtn = e.target.closest('[data-cancel-swap]');
    if (cancelSwapBtn) {
      replaceLineId = null;
      renderMontraGrid();
      showToast('Modo de substituição cancelado');
      return;
    }
    const pvBtn = e.target.closest('[data-panel-view]');
    if (pvBtn) {
      replaceLineId = null;
      if (pvBtn.dataset.panelView === 'menu' && currentPanelView === 'product') { returnToExhibition(); return; }
      setPanelView(pvBtn.dataset.panelView);
      return;
    }
    const selBtn = e.target.closest('[data-select-product]');
    if (selBtn && selBtn.id !== 'hero-open-product') {
      if(selBtn.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
      e.preventDefault();
      openCounterProductCard(selBtn.dataset.selectProduct);
      return;
    }
    if(e.target.closest('[data-open-party-planner]')){e.preventDefault();openPartyPlanner();return;}
    const openBtn = e.target.closest('[data-open-drawer]');
    if (openBtn) {
      if(openBtn.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
      e.preventDefault();
      if (openBtn.hasAttribute('data-clear-swap')) {
        replaceLineId = null;
      }
      if (openBtn.dataset.openDrawer === 'montra' && document.body.dataset.drawer !== 'comunidade') openStationCatalogue('loja', 'Todos');
      else openDrawer(openBtn.dataset.openDrawer);
      return;
    }
    const tabBtn = e.target.closest('[data-drawer-tab]');
    if (tabBtn) {
      openDrawer(tabBtn.dataset.drawerTab);
      return;
    }
    const closeBtn = e.target.closest('[data-close-drawer]');
    if (closeBtn) {
      replaceLineId = null;
      setPanelView('menu');
    }
  });

  // Alteração de formato dentro do Spotlight da Vitrina Real e Seletores de Comparação
  document.addEventListener('change', (e) => {
    const vitVarSelect = e.target.closest('[data-vitrina-variant]');
    if (vitVarSelect) {
      const handle = vitVarSelect.dataset.vitrinaVariant;
      selectedVariants[handle] = Number(vitVarSelect.value);
      renderVitrinaStrip();
      return;
    }
    const compVarSelect = e.target.closest('[data-compare-variant]');
    if (compVarSelect) {
      const handle = compVarSelect.dataset.compareVariant;
      selectedVariants[handle] = Number(compVarSelect.value);
      renderCompareModal();
      playPorcelainChime(587.33);
      return;
    }
    const compSelect = e.target.closest('[data-compare-select]');
    if (compSelect) {
      const chosen = compSelect.value;
      if (compSelect.dataset.compareSelect === 'left') {
        if (chosen === compareRightHandle) {
          compareRightHandle = compareLeftHandle;
        }
        compareLeftHandle = chosen;
      } else {
        if (chosen === compareLeftHandle) {
          compareLeftHandle = compareRightHandle;
        }
        compareRightHandle = chosen;
      }
      renderCompareModal();
      playPorcelainChime(587.33);
    }
  });

  // Botão Voltar no rodapé do painel (#panel-back-btn)
  $('#panel-back-btn')?.addEventListener('click', () => {
    if (document.body.classList.contains('entrance-proof')) { goBackInPanel(); return; }
    const drawer = $('#store-drawer');
    if (drawer && !drawer.hidden) {
      replaceLineId = null;
      closeDrawer();
      return;
    }
    if (currentPanelView === 'product') {
      returnToExhibition();
    } else if (currentPanelView === 'menu') {
      setPanelView('welcome');
    } else {
      setPanelView('menu');
    }
  });

  // Botões de estação ([data-station])
  $$('[data-station]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const st = btn.dataset.station;
      if (st === 'bolos' || st === 'salgados') { openStationCatalogue(st); return; }
      activeStation = st;
      document.body.classList.remove('mobile-panel-expanded');
      const retBar = $('#station-return-bar');
      if (retBar) retBar.hidden = st === 'loja' || st === 'entrada' || st === 'balcao';
      if (scene3d) scene3d.goToStation(st);
      renderVitrinaStrip();
    });
  });

  // Botões das 6 poses de verificação espacial ([data-pose])
  $$('[data-pose]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const poseId = btn.dataset.pose;
      activeStation = 'loja';
      panelNear = poseId === 'near';
      const distBtn = $('#panel-distance');
      if (distBtn) {
        distBtn.textContent = panelNear ? 'Voltar à loja' : 'Aproximar painel';
        distBtn.setAttribute('aria-expanded', String(panelNear));
      }
      document.body.classList.remove('mobile-panel-expanded');
      const retBar = $('#station-return-bar');
      if (retBar) retBar.hidden = true;
      $$('[data-pose]').forEach((b) => b.classList.toggle('is-active', b.dataset.pose === poseId));
      if (scene3d) scene3d.goToGatePose(poseId);
      renderVitrinaStrip();
    });
  });

  $('#return-room-entry')?.addEventListener('click', () => {
    if (scene3d) { scene3d.goToGatePose('entrada'); $('#bakery-canvas').focus({preventScroll:true}); }
  });

  // Controlos da Ficha de Produto (#counter-product-card)
  $('#cp-close')?.addEventListener('click', () => {
    returnToExhibition();
  });

  $('#cp-zoom-btn')?.addEventListener('click', () => {
    openPhotoModal(selectedHandle);
  });
  $('#cp-zoom-pill-btn')?.addEventListener('click', () => {
    openPhotoModal(selectedHandle);
  });

  $('#cp-variant')?.addEventListener('change', (e) => {
    selectedVariants[selectedHandle] = Number(e.target.value);
    openCounterProductCard(selectedHandle);
  });

  const handleCpQtyUpdate = e => {
    const val = readProductQuantity(e.target.value);
    if (val !== null) selectedQuantities[selectedHandle] = val;
    updateCounterProductPriceAndCTA(getProduct(selectedHandle), val);
  };
  $('#cp-qty')?.addEventListener('input', handleCpQtyUpdate);
  $('#cp-qty')?.addEventListener('change', handleCpQtyUpdate);

  $('#cp-add-btn')?.addEventListener('click', () => {
    addCurrentProductToBasket();
  });

  $('#cp-swap-btn')?.addEventListener('click', (e) => {
    const lineId = e.currentTarget.dataset.swapLineId;
    if (lineId) {
      replaceLineId = lineId;
      addCurrentProductToBasket();
    }
  });

  $('#cp-ask-larrysa')?.addEventListener('click', () => {
    const p = getProduct(selectedHandle);
    openDrawer('ajuda');
    if (p) {
      sendMessageToLarrysa(`Como é o ${p.name}? Combina bem com uma celebração?`);
    }
  });

  // Filtros e pesquisa do Menu Completo (34 produtos)
  $$('[data-filter-cat]').forEach((btn) => {
    btn.addEventListener('click', () => {
      activeCategoryFilter = btn.dataset.filterCat;
      $$('[data-filter-cat]').forEach((b) => { b.classList.toggle('is-active', b.dataset.filterCat === activeCategoryFilter); b.setAttribute('aria-pressed', String(b.dataset.filterCat === activeCategoryFilter)); });
      renderMontraGrid();
    });
  });

  $('#montra-search')?.addEventListener('input', (e) => {
    searchQuery = e.target.value;
    activeTasteFilter = '';
    $$('[data-taste-filter]').forEach((b) => b.classList.toggle('is-active', b.dataset.tasteFilter === searchQuery && Boolean(searchQuery)));
    renderMontraGrid();
  });

  $('#montra-grid')?.addEventListener('click', (e) => {
    if (e.target.closest('[data-cancel-swap]')) return;
    const btn = e.target.closest('[data-inspect-on-counter], [data-montra-product]');
    if (!btn) return;
    const handle = btn.dataset.inspectOnCounter || btn.dataset.montraProduct;
    openCounterProductCard(handle);
    // Acessibilidade: levar o foco para o título da ficha aberta
    const cpTitle = $('#cp-title');
    if (cpTitle && !$('#counter-product-card')?.hidden) { cpTitle.setAttribute('tabindex', '-1'); cpTitle.focus({ preventScroll: true }); }
  });

  // Conversa com a Larrysa
  $$('[data-prompt]').forEach((btn) => {
    btn.addEventListener('click', () => {
      sendMessageToLarrysa(btn.dataset.prompt);
    });
  });

  $('#chat-form')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = $('#chat-input');
    if (input?.value) sendMessageToLarrysa(input.value);
  });

  $('#chat-log')?.addEventListener('click', (e) => {
    const inspectBtn = e.target.closest('[data-chat-inspect]');
    if (inspectBtn) {
      closeDrawer();
      openCounterProductCard(inspectBtn.dataset.chatInspect);
      return;
    }
    const addBtn = e.target.closest('[data-chat-add]');
    if (addBtn) {
      addCurrentProductToBasket(addBtn.dataset.chatAdd, 1);
      return;
    }
    const swapBtn = e.target.closest('[data-chat-swap]');
    if (swapBtn) {
      replaceLineId = swapBtn.dataset.chatSwap;
      addCurrentProductToBasket(swapBtn.dataset.targetHandle, visit.basket.find(l => l.id === replaceLineId)?.quantity || 1,replaceLineId);
    }
  });

  // Eventos no Pedido (#order-container)
  $('#order-container')?.addEventListener('click', async (e) => {
    if (e.target.closest('[data-edit-order]')) {
      $('#order-final-review').open = false;
      $('#order-date')?.focus();
      return;
    }
    const guestBtn = e.target.closest('[data-guest-target]');
    if (guestBtn) {
      const n = Number(guestBtn.dataset.guestTarget || 0);
      if (n > 0) {
        visit.brief = { ...(visit.brief || {}), people: n };
      } else if (visit.brief) {
        delete visit.brief.people;
      }
      renderOrderDrawer();
      persistVisit();
      playPorcelainChime(587.33);
      return;
    }
    if (e.target.closest('[data-review-private-context]')) {
      visit.privateContextPending = false;
      renderOrderDrawer();
      persistVisit();
      $('#order-note')?.focus();
      return;
    }
    const datePresetBtn = e.target.closest('[data-date-preset]');
    if (datePresetBtn) {
      const val = datePresetBtn.dataset.datePreset || '';
      visit.details.date = val;
      renderOrderDrawer();
      persistVisit();
      playPorcelainChime(587.33);
      return;
    }
    const inspectPieceBtn = e.target.closest('.order-marble-table-stage [data-inspect-on-counter]');
    if (inspectPieceBtn) {
      const h = inspectPieceBtn.dataset.inspectOnCounter;
      closeDrawer();
      openCounterProductCard(h);
      return;
    }
    const presetBtn = e.target.closest('[data-dedication-preset]');
    if (presetBtn) {
      const text = presetBtn.dataset.dedicationPreset || '';
      visit.details.dedication = text;
      const noteInput = $('#order-dedication');
      if (noteInput) noteInput.value = text;
      refreshWhatsappPreviewInPlace();
      persistVisit();
      playPorcelainChime(659.25);
      return;
    }
    const pairBtn = e.target.closest('[data-order-quick-add]');
    if (pairBtn) {
      addCurrentProductToBasket(pairBtn.dataset.orderQuickAdd, 1);
      playPorcelainChime(659.25);
      return;
    }
    const rmBtn = e.target.closest('[data-basket-remove]');
    if (rmBtn) {
      if(!await commitBasket(visit.basket.filter((l) => l.id !== rmBtn.dataset.basketRemove)))return;
      updateBasketUI();
      persistVisit();
      showToast('Produto removido do pedido');
      return;
    }
    const swBtn = e.target.closest('[data-basket-swap]');
    if (swBtn) {
      replaceLineId = swBtn.dataset.basketSwap;
      replacementProduct = null;
      activeCategoryFilter = 'Todos'; searchQuery = '';
      openDrawer('montra');
      showToast('Escolha na montra o produto para substituir esta linha');
      return;
    }
    const sendBtn = e.target.closest('#btn-whatsapp-send');
    if (sendBtn && (sendBtn.getAttribute('aria-disabled') === 'true'||sharedCart&&!sharedCart.ready)) {
      e.preventDefault();
      const issues = Object.values(orderIssues());
      showToast(issues[0] || 'Confirme os dados do pedido antes de continuar');
      return;
    }
    if (e.target.id === 'btn-copy-message') {
      const text = $('#whatsapp-preview-text')?.value || '';
      if (!text || Object.keys(orderIssues()).length) return;
      try {
        await navigator.clipboard.writeText(text);
        showToast('Mensagem copiada para a área de transferência');
      } catch {
        const preview = $('#whatsapp-preview-text'); preview?.focus(); preview?.select?.();
        showToast('Não foi possível copiar automaticamente. Copie o texto selecionado e cole-no no WhatsApp.');
      }
    }
  });

  $('#order-container')?.addEventListener('change', async (e) => {
    const qtyInput = e.target.closest('[data-line-quantity]');
    if (qtyInput) {
      const lineId = qtyInput.dataset.lineQuantity;
      const newQty = Number(qtyInput.value);
      if (!Number.isSafeInteger(newQty) || newQty < 1 || newQty > 99) {
        qtyInput.value = String(visit.basket.find(l => l.id === lineId)?.quantity || 1);
        showToast('Escolha uma quantidade inteira entre 1 e 99');
        return;
      }
      if(!await commitBasket(visit.basket.map((l) => (l.id === lineId ? { ...l, quantity: newQty } : l)))){qtyInput.value=String(visit.basket.find(l=>l.id===lineId)?.quantity||1);return;}
      updateBasketUI();
      persistVisit();
      return;
    }
    if (e.target.id === 'order-date') {
      visit.details.date = e.target.value;
      if (detailIssues(visit.details).date) showToast('Escolha uma data futura ou deixe por combinar');
      renderOrderDrawer();
      persistVisit();
    } else if (e.target.id === 'order-receive') {
      visit.details.receive = e.target.value;
      renderOrderDrawer();
      persistVisit();
    }
  });

  $('#order-container')?.addEventListener('input', (e) => {
    const qtyInput = e.target.closest('[data-line-quantity]');
    if (qtyInput) {
      if(sharedCart)return;
      const q = Number(qtyInput.value);
      if (!Number.isInteger(q) || q < 1 || q > 99) return;
      visit.basket = visit.basket.map(l => l.id === qtyInput.dataset.lineQuantity ? { ...l, quantity: q } : l);
      const sum = basketSummary(visit.basket, catalogue);
      $('#basket-subtotal').textContent = money(sum.total);
      refreshWhatsappPreviewInPlace();
      persistVisit();
      return;
    }
    if (e.target.id === 'order-zone') {
      visit.details.zone = e.target.value;
      refreshWhatsappPreviewInPlace();
      persistVisit();
    } else if (e.target.id === 'order-dedication') {
      visit.details.dedication = e.target.value;
      refreshWhatsappPreviewInPlace();
      persistVisit();
    } else if (e.target.id === 'order-allergies') {
      visit.details.allergies = e.target.value;
      refreshWhatsappPreviewInPlace();
      persistVisit();
    } else if (e.target.id === 'order-note') {
      visit.details.note = e.target.value;
      refreshWhatsappPreviewInPlace();
      persistVisit();
    } else if (e.target.id === 'order-additional-message') {
      visit.preparedText = e.target.value;
      const sendLink = $('#btn-whatsapp-send');
      if (sendLink) {
        refreshWhatsappPreviewInPlace();
      }
      persistVisit();
    }
  });

  // Modal da Fotografia Original
  $('#pm-close')?.addEventListener('click', () => {
    $('#photo-modal')?.close();
  });
  $('#pm-toggle-zoom')?.addEventListener('click', (e) => {
    const vp = $('#pm-viewport');
    if (!vp) return;
    const zoomed = vp.classList.toggle('is-zoomed');
    e.currentTarget.textContent = zoomed ? 'Ver fotografia inteira' : 'Ampliar detalhes';
  });

  window.addEventListener('pageshow',event=>{if(event.persisted)return refreshSharedCart();});
  window.addEventListener('focus',()=>{if(sharedCart?.ready)return refreshSharedCart();});
  document.addEventListener('click',async event=>{const link=event.target.closest('[data-shared-cart-exit]');if(link){event.preventDefault();if(await confirmSharedCartExit())location.assign(link.href);}});
  window.addEventListener('pagehide', () => {
    persistVisit({ immediate: true });
  });
}

async function boot() {
  await loadCatalogueAndMedia();
  await restoreVisit();
  if(window.LarrysaShopifyConfig?.sharedCart){
   sharedCart=createSharedCart(globalThis.fetch.bind(globalThis),catalogue,window.LarrysaShopifyConfig.cartRoot||'/');
   // Browsing does not wait for cart I/O; writes remain blocked by sharedCart.ready.
   refreshSharedCart();
  }
  if (visit.preparedText?.startsWith('Olá, equipa')) visit = migratePreparedNote({ ...visit, preparedFor: 'legacy' });
  $('#chat-input').value = visit.unsent || '';


  const params = new URLSearchParams(location.search);
  if(window.LarrysaShopifyConfig){params.set('prova','cartaz');params.set('entrada','campanha');}
  document.body.classList.toggle('is-inspection', params.get('inspecao') === '1');
  const savedPrefs = loadUIPrefs();
  const paramDir = params.get('direcao');
  const initialDir =
    paramDir === 'herbario' || paramDir === 'cacau'
      ? paramDir
      : savedPrefs.direction === 'herbario'
        ? 'herbario'
        : 'cacau';
  document.documentElement.dataset.direction = initialDir;
  document.documentElement.dataset.exhibition = initialDir;
  const dirSelect = $('#direction-select');
  if (dirSelect) dirSelect.value = initialDir;

  const paramLight = params.get('luz');
  const initialLight = ['manha', 'tarde', 'noite'].includes(paramLight)
    ? paramLight
    : ['manha', 'tarde', 'noite'].includes(savedPrefs.lighting)
      ? savedPrefs.lighting
      : detectLisbonLightingMood();
  document.documentElement.dataset.lighting = initialLight;
  const lightSelect = $('#lighting-select');
  if (lightSelect) lightSelect.value = initialLight;
  syncOvenTicker(initialLight);

  const canvas = $('#bakery-canvas');
  const anchorsRoot = $('#spatial-anchors');
  const shopPanelEl = $('#shop-panel');

  try {
    // No telemóvel a montra é estática; não descarregar Three nem construir a cena.
    if (matchMedia('(max-width:700px)').matches && globalThis.LarrysaHubFlags?.mobile3D !== true) throw new Error('telemóvel: imagem fixa');
    const sceneModule = await import("./lh-97c689be-scene-3d.js?v=codex-20261027-r14");
    GATE_POSES = sceneModule.GATE_POSES;
    scene3d = new sceneModule.BakeryScene3D({
    canvas,
    anchorsRoot,
    shopPanelEl,
    onSelectProduct: (slug) => {
      openCounterProductCard(slug);
    },
    onSelectStation: (stationId) => {
      if (stationId === 'bolos' || stationId === 'salgados') { openStationCatalogue(stationId); return; }
      activeStation = stationId;
      const retBar = $('#station-return-bar');
      if (retBar) retBar.hidden = stationId === 'loja' || stationId === 'entrada' || stationId === 'balcao';
      scene3d.goToStation(stationId);
      renderVitrinaStrip();
    },
    onSelectLarrysa: () => {
      openDrawer('ajuda');
    },
    onOpenMontra: () => {
      openDrawer('montra');
    },
    onPoseChange: (poseInfo) => {
      const labelEl = $('#hud-location-badge');
      if (labelEl) {
        const gate = GATE_POSES[poseInfo.poseId];
        labelEl.textContent = gate
          ? gate.label
          : 'Loja 3D';
      }
    }
  });

    await scene3d.init();
    scene3d.setDirection(initialDir);
    scene3d.setLightingMood(initialLight);
  } catch (error) {
    if (!/telemóvel/.test(error.message)) console.warn('A visita continua sem aceleração 3D.', error.message);
    scene3d = null;
    document.body.classList.add('is-static-store');
  }

  previewFeaturedCakeInHero(selectedHandle || 'flor-citrica');
  initBakeryStory();
  setupUIEvents();
  renderVitrinaStrip();
  updateBasketUI();

  if (params.get('vista') === 'boas-vindas') {
    setPanelView('welcome');
  } else {
    setPanelView('menu');
  }

  const initialPose = params.get('pose');
  if (scene3d && initialPose && GATE_POSES[initialPose]) {
    scene3d.setPoseImmediate(GATE_POSES[initialPose], initialPose);
    $$('[data-pose]').forEach((b) => b.classList.toggle('is-active', b.dataset.pose === initialPose));
  }

  journeyReady = true;
  setPanelExpanded(false);
  $$('.display-card[data-featured-cake]').forEach(card => { const p = getProduct(card.dataset.featuredCake); if (p) { card.querySelector('img').src = p.originalImageResolved; framePhotograph(card.querySelector('img'),p); } });
  const welcomePhoto = $('.welcome-product img'); if (welcomePhoto) welcomePhoto.src = (getProduct('rubra') || catalogue[0]).originalImageResolved;

  // API determinística para verificação automatizada
  window.__lojaViva3D = {
    scene3d,
    setGatePoseImmediate: (poseId) => {
      if (GATE_POSES[poseId]) {
        activeStation = 'loja';
        document.body.classList.remove('mobile-panel-expanded');
        const retBar = $('#station-return-bar');
        if (retBar) retBar.hidden = true;
        scene3d.setPoseImmediate(GATE_POSES[poseId], poseId);
        $$('[data-pose]').forEach((b) => b.classList.toggle('is-active', b.dataset.pose === poseId));
        renderVitrinaStrip();
      }
    },
    inspectProduct: (handle) => openCounterProductCard(handle),
    setCounterQuantity: (handle, qty) => {
      selectedQuantities[handle] = qty;
      openCounterProductCard(handle);
    },
    openDrawer,
    closeDrawer,
    setPanelView,
    getCatalogueCount: () => catalogue.length,
    getBasketSummary: () => basketSummary(visit.basket, catalogue)
  };
  // Opt-in local design proof; the existing shopping state remains the owner.
  if (params.get('prova') === 'cartaz') {
    const {mountPosterProof} = await import("./lh-8d55a1fd-poster-proof.js?v=codex-20261027-r14");
    mountPosterProof({getProduct, previewFeaturedCakeInHero, openCounterProductCard, setPanelView, setPanelExpanded, openDrawer, closeDrawer, scene3d});
    if (['acolhimento','tres-mundos','campanha'].includes(params.get('entrada'))) {
      const {mountEntranceProof} = await import("./lh-47531190-entrance-proof.js?v=codex-20261027-r14");
      mountEntranceProof({getProduct, openDrawer, setPanelView, openCategory: category => openStationCatalogue(category === 'Bolos' ? 'bolos' : 'salgados', category)});
    }
  }
  const displayImage = $('#campaign-image') || $('#poster-image') || $('#hero-cake-img');
  if (displayImage?.src) {
    try { await displayImage.decode(); }
    catch { await displayImage.decode(); } // Campaign error handler may have selected the original photo.
  }
  scene3d?.setDisplayImage(displayImage);
  $('#return-room-entry').hidden = !scene3d;
  document.body.dataset.shopReady = 'true';
  window.larrysaApplyLang?.();
  if(window.LarrysaShopifyConfig)document.body.dataset.socialReady='true';
  if (!visitStorageAvailable) {
    $('#drawer-save-retry').hidden = true;
    $('#drawer-save-text').textContent = T('As escolhas continuam neste separador. O navegador não garante a recuperação do pedido depois de fechar ou recarregar a página.');
    $('#drawer-save-banner').hidden = false;
  }
}

boot().catch((err) => {
  console.error(err);
  document.body.dataset.shopReady = 'error';
  document.body.dataset.catalogueUnavailable = String(catalogue.length === 0);
  document.body.classList.add('is-static-store');
  $('#fallback-stage').hidden = false;
  $('#store-startup-text').textContent = catalogue.length === 0
    ? 'Não foi possível carregar o catálogo. Tente novamente para consultar os produtos e preparar o pedido.'
    : 'Não foi possível abrir a loja. Tente novamente; as escolhas guardadas neste navegador serão recuperadas quando possível.';
  $('#store-startup-status').setAttribute('role', 'alert');
  $('#store-startup-status').hidden = false;
});

document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseBakeryStory();});

// Keep generated copy in the selected language. Private chat and notes are excluded by i18n.js.
window.addEventListener('larrysa:lang', () => window.larrysaApplyLang?.());
function askAllergyHref() {
  const en = false;
  const text = en
    ? "Hello, Larrysa's Bakery! Before ordering, I'd like to ask about ingredients and allergens."
    : "Olá, Larrysa's Bakery! Antes de encomendar, gostaria de perguntar sobre ingredientes e alergénios.";
  return `https://wa.me/${window.LARRYSA_WA || ''}?text=${encodeURIComponent(text)}`;
}
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[data-wa-ask-allergy]');
  if (link) link.href = askAllergyHref();
}, true);
window.addEventListener('larrysa:lang', () => {
  document.querySelectorAll('a[data-wa-ask-allergy]').forEach((link) => { link.href = askAllergyHref(); });
});

// Fase 3 (27 Out 2026): "Dúvidas" com respostas fixas escritas pela casa, sem rede para o servidor.
// A IA só volta com LarrysaHubFlags.assistantAI === true, depois de passar 18/18 testes.

const faqMapsUrl = 'https://www.google.com/maps/search/?api=1&query=Larrysa%27s+Bakery&query_place_id=ChIJ46UoEEaUNG8RmcG4Kk8Iiic';
function faqEn() { return window.larrysaLang === 'en'; }
function faqNorm(s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
function faqList() {
  return [
    { id: 'entregas', re: /entreg|estafeta|deliver|uber|glovo|domicil|levar a casa|envia(m|r)? para/,
      q: ['Como recebo a encomenda?', 'How do I get my order?'],
      a: ['A recolha é na Pontinha. Combine connosco a janela de recolha.',
          "Pickup is in Pontinha. Please agree the collection window with us."] },
    { id: 'horario', re: /horario|domingo|abert|abrem|fecham|sunday|opening|hours|open on/,
      q: ['Qual é o horário? Abrem ao domingo?', 'What are your opening hours? Are you open on Sundays?'],
      a: ['De segunda a sábado, das 8h às 22h. Ao domingo só recebemos encomendas.',
          'Monday to Saturday, 8am to 10pm. On Sundays we only take orders.'] },
    { id: 'confirmada', re: /confirm/,
      q: ['A encomenda fica confirmada?', 'Is my order confirmed?'],
      a: ['Ainda não. Respondemos no WhatsApp com a disponibilidade e o valor final. A encomenda só fica reservada depois do sinal.',
          'Not yet. We reply on WhatsApp with availability and the final price. Your order is only reserved after the deposit.'] },
    { id: 'como', re: /como (faco|fazer|posso|se faz)|como encomend|fazer (uma |a )?encomenda|how (do|can) i (order|place)|place an order/,
      q: ['Como faço uma encomenda?', 'How do I place an order?'],
      a: ['Escolha os produtos na montra, diga-nos para quando precisa e carregue em “Continuar no WhatsApp”. A mensagem vai pronta; só tem de a enviar.',
          'Choose your products from the counter, tell us when you need them and tap “Continue on WhatsApp”. The message is ready; you just need to send it.'] },
    { id: 'sinal', re: /sinal|deposit|pagamento|pagar|mb ?way|multibanco|pay/,
      q: ['Quanto é o sinal?', 'How much is the deposit?'],
      a: ['50% do valor, pago depois de confirmarmos a disponibilidade. O restante paga na recolha.',
          '50% of the total, paid after we confirm availability. You pay the rest at pickup.'] },
    { id: 'alergias', re: /gluten|lactose|frutos secos|nozes|amendoi|alerg|intoler|vegan|ingredient|\bnuts?\b|dairy|\bovos?\b|\beggs?\b|celiac|celiac/,
      q: ['Tem glúten, frutos secos ou lactose?', 'Does it contain gluten, nuts or lactose?'],
      a: ['Trabalhamos com os 14 alergénios de declaração obrigatória, como glúten, ovos, leite e frutos secos. Antes de encomendar, diga-nos se tem alguma alergia ou intolerância.',
          "Our kitchen handles the 14 major allergens, such as gluten, eggs, milk and nuts. Before ordering, please tell us about any allergy or intolerance."] },
    { id: 'preco', re: /preco|custa|custam|quanto fica|price|cost|how much/,
      q: ['Quanto custa um produto?', 'How much does a product cost?'],
      a: ['Cada produto mostra o preço na montra. Diga-nos qual procura e confirmamos o valor final no WhatsApp.',
          'Every product shows its price on the counter. Tell us which one you are looking for and we will confirm the final price on WhatsApp.'] },
    { id: 'pessoas', re: /\d+\s*(pessoas|people|convidados|guests|pax)|muitas pessoas|para quantas|lots of people|many people/,
      q: ['Preciso de um bolo para muitas pessoas', 'I need a cake for a lot of people'],
      a: ['Diga-nos quantas pessoas são e para quando precisa. Vemos a disponibilidade e propomos o tamanho certo no WhatsApp.',
          "Tell us how many people and when you need it. We'll check availability and suggest the right size on WhatsApp."] },
    { id: 'onde', re: /onde|morada|localiza|endereco|address|where|location|mapa|\bmaps?\b/,
      q: ['Onde ficam?', 'Where are you?'],
      a: ['Estamos na Pontinha. A recolha na loja é gratuita.', "We're in Pontinha. Pickup at the shop is free."], maps: true }
  ];
}
function faqProductName(p) { return faqEn() ? (window.LARRYSA_EN?.[p.name] || p.name) : p.name; }
function faqFindProducts(text) {
  const t = faqNorm(text);
  return catalogue.filter(p => {
    const names = [p.name, window.LARRYSA_EN?.[p.name]].filter(Boolean).map(faqNorm);
    const short = names.map(n => n.replace(/^(bolo|cake)\s+/, ''));
    return names.concat(short).some(n => n.length > 3 && t.includes(n));
  }).slice(0, 4);
}
function faqCategory(text) {
  const t = faqNorm(text);
  if (/salgad|savour|savor/.test(t)) return 'Salgados';
  if (/sobremes|dessert/.test(t)) return 'Sobremesas';
  if (/\bbolos\b|\bcakes\b/.test(t)) return 'Bolos';
  return '';
}
function faqMatch(text) {
  const t = faqNorm(text), en = faqEn() ? 1 : 0, list = faqList();
  const hits = list.filter(f => f.re.test(t));
  const products = faqFindProducts(text), category = faqCategory(text);
  const parts = [];
  let maps = false;
  for (const f of hits) {
    if (parts.length >= 2) break;
    if (f.id === 'preco' && (products.length || category)) continue;
    parts.push(f.a[en]);
    if (f.maps) maps = true;
  }
  const priceAsked = hits.some(f => f.id === 'preco') || (!hits.length && products.length);
  if (priceAsked && products.length) {
    parts.unshift(products.map(p => `${faqProductName(p)}: ${p.priceLabel}`).join('\n') + '\n' + (en ? 'The final price is confirmed on WhatsApp.' : 'O valor final é confirmado no WhatsApp.'));
  } else if (priceAsked && category) {
    const items = catalogue.filter(p => p.category === category).slice(0, 8);
    if (items.length) parts.unshift(items.map(p => `${faqProductName(p)}: ${p.priceLabel}`).join('\n') + '\n' + (en ? 'The final price is confirmed on WhatsApp.' : 'O valor final é confirmado no WhatsApp.'));
  }
  if (!parts.length && /ninho/.test(t) && !products.length) {
    parts.push(en ? "That product isn't on our counter right now. Ask us on WhatsApp whether we can make it." : 'Neste momento esse produto não está na montra. Pergunte-nos no WhatsApp se conseguimos fazê-lo.');
  }
  return parts.length ? { text: parts.join('\n\n'), maps } : null;
}
function faqAskHref(question) {
  const fixed = faqList().find(f => f.q.includes(question));
  const text = fixed
    ? "Olá, Larrysa's Bakery! Tenho uma dúvida: " + fixed.q[0]
    : "Olá, Larrysa's Bakery! Gostaria de falar com a equipa sobre a pastelaria.";
  return `https://wa.me/${window.LARRYSA_WA || ''}?text=${encodeURIComponent(text)}`;
}
function faqButtonsHtml() {
  const en = faqEn() ? 1 : 0;
  const order = ['entregas', 'horario', 'como', 'confirmada', 'sinal', 'alergias', 'preco', 'pessoas', 'onde'];
  return faqList().sort((x, y) => order.indexOf(x.id) - order.indexOf(y.id)).map(f => `<button type="button" data-faq="${esc(f.id)}">${esc(f.q[en])}</button>`).join('');
}
function faqBubbleHtml(m) {
  const en = faqEn();
  if (m.role === 'user') return `<div class="chat-bubble user"><div>${esc(m.text)}</div></div>`;
  if (m.thinking) return `<div class="chat-bubble assistant is-thinking" aria-busy="true"><div>${en ? 'Thinking' : 'A pensar'}<span class="faq-dots" aria-hidden="true"><i></i><i></i><i></i></span></div></div>`;
  const ask = `<a class="secondary faq-ask-wa" data-wa-keep href="${esc(faqAskHref(m.ask || ''))}" target="_blank" rel="noopener noreferrer">${en ? 'Talk to the team on WhatsApp' : 'Falar com a equipa no WhatsApp'} ↗</a>`;
  if (!m.answer) {
    const lead = m.reason === 'scope'
      ? (en ? "I can only help with Larrysa's Bakery: orders, pickup in Pontinha, opening hours, the deposit, allergies and the products on our counter." : "Só posso ajudar com dúvidas sobre a Larrysa's Bakery: encomendas, recolha na Pontinha, horário, sinal, alergias e produtos da montra.")
      : m.reason === 'fail'
        ? (en ? "I couldn't answer that here. Choose a question below or talk to the team on WhatsApp." : 'Não consegui responder a isso aqui. Escolha uma pergunta abaixo ou fale com a equipa no WhatsApp.')
        : (en ? 'I can help with these questions:' : 'Posso ajudar com estas perguntas:');
    return `<div class="chat-bubble assistant" data-hub-copy-en><div>${lead}</div><div class="faq-choices">${faqButtonsHtml()}</div><div class="faq-actions">${ask}</div></div>`;
  }
  const maps = m.answer.maps ? `<a class="secondary" href="${faqMapsUrl}" target="_blank" rel="noopener noreferrer">${en ? 'Open in Google Maps' : 'Abrir no Google Maps'} ↗</a>` : '';
  const aiNote = m.answer.ai ? `<small class="faq-ai-note">${en ? 'Automatic answer · the team confirms everything on WhatsApp' : 'Resposta automática · a equipa confirma tudo no WhatsApp'}</small>` : '';
  return `<div class="chat-bubble assistant" data-hub-copy-en><div>${esc(m.answer.text)}</div>${aiNote}<div class="faq-actions">${maps}${ask}</div></div>`;
}
function answerFixed(text, faqId) {
  const en = faqEn() ? 1 : 0;
  const f = faqId ? faqList().find(x => x.id === faqId) : null;
  const question = f ? f.q[en] : String(text || '').trim().slice(0, 600);
  if (!question) return;
  const match = f ? { text: f.a[en], maps: Boolean(f.maps) } : faqMatch(question);
  visit.chatMessages.push({role:'user',text:question},{role:'assistant',text:match?.text || T('A equipa pode esclarecer essa dúvida no WhatsApp.'),actions:[{type:'continue_whatsapp'}]});
  visit.chatHistory = [...visit.chatHistory,{role:'user',text:question},{role:'assistant',text:match?.text || ''}].slice(-6);
  const input = $('#chat-input');
  if (input && !f) input.value = '';
  visit.unsent = '';
  const status = $('#chat-status');
  if (status) status.textContent = '';
  persistVisit();
  renderChatMessages();
}
document.addEventListener('click', (event) => {
  const b = event.target.closest?.('[data-faq]');
  if (!b) return;
  event.preventDefault();
  answerFixed('', b.dataset.faq);
});
window.addEventListener('larrysa:lang', () => { if ($('#chat-log')) renderChatMessages(); });

